
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Paper,
//   useMediaQuery,
//   useTheme,
//   List,
//   ListItem,
//   ListItemText,
//   Popper,
//   Grow,
//   ClickAwayListener,
//   MenuItem,
//   Select,
//   FormControl,
//   FormHelperText,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Dialog,
//   DialogContent,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import CloudUpload from '@mui/icons-material/CloudUpload';
// import LinkIcon from '@mui/icons-material/Link';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../Commonlibs/userSlice';
// import PostAccess from './PostAccess';

// // Import icons
// import apartmentIcon from "../assets/appsell.png";
// import independentHouseIcon from "../assets/apphouse.png";
// import duplexIcon from "../assets/appduple.png";
// import pentHouseIcon from "../assets/apppent.png";
// import villaIcon from "../assets/appvilla.png";
// import studioIcon from "../assets/appstudio.png";
// import plotIcon from "../assets/appplot.png";
// import agricultureLandIcon from "../assets/appagri.png";
// import farmHouseIcon from "../assets/appfarm.png";
// import socialMediaIcon from '../assets/appyoutu.png';
// import OfficeIcon from '../assets/officecomm.png';
// import ShowroomIcon from '../assets/showcomm.png';
// import RetailShopIcon from '../assets/retailcomm.png';
// import WarehouseIcon from '../assets/ware comm.png';
// import CommercialPlotIcon from '../assets/plotcomm.png';
// import OthersIcon from '../assets/otherscomm.png';

// const base64ToFile = async (base64String, filename) => {
//   try {
//     const response = await fetch(base64String);
//     const blob = await response.blob();
//     return new File([blob], filename, { type: blob.type });
//   } catch (error) {
//     console.error('Error converting base64 to file:', error);
//     return null;
//   }
// };

// const PropertyDetails = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();
//   const location = useLocation();
//   const {
//     propertyType = 'Residential',
//     category = 'Sell',
//     location: propLocation = ''
//   } = location.state || {};

//   const user = useSelector(selectUser);
//   const userId = user?.id;

//   // ✅ Load persisted state
//   const loadPersistedState = () => {
//     const saved = localStorage.getItem('propertyDetailsFormState');
//     if (saved) {
//       try {
//         return JSON.parse(saved);
//       } catch (e) {
//         console.error('Error parsing saved state:', e);
//         return location.state || {};
//       }
//     }
//     return location.state || {};
//   };

//   const persistedState = loadPersistedState();

//   // State declarations
//   const [profileData, setProfileData] = useState(null);
//   const [loadingProfile, setLoadingProfile] = useState(true);
//   const [propertyImages, setPropertyImages] = useState([]);
//   const [imagesLoaded, setImagesLoaded] = useState(false);
//   const [imagePreviews, setImagePreviews] = useState([]);
//   const [propertyVideos, setPropertyVideos] = useState(persistedState.propertyVideos || []);
//   const [buildingName, setBuildingName] = useState(persistedState.buildingName || '');
//   const [areaName, setAreaName] = useState(persistedState.areaName || '');
//   const [completeAddress, setCompleteAddress] = useState(persistedState.completeAddress || '');
//   const [locality, setLocality] = useState(persistedState.locality || '');
//   const [landmark, setLandmark] = useState(persistedState.landmark || '');
//   const [propertyDescription, setPropertyDescription] = useState(persistedState.propertyDescription || '');
//   const [propertySize, setPropertySize] = useState(persistedState.propertySize || '');
//   const [selectedUnit, setSelectedUnit] = useState(persistedState.selectedUnit || 'sq.yards');
//   const [propertyLength, setPropertyLength] = useState(persistedState.propertyLength || '');
//   const [lengthUnit, setLengthUnit] = useState(persistedState.lengthUnit || 'Sq.Ft');
//   const [propertyWidth, setPropertyWidth] = useState(persistedState.propertyWidth || '');
//   const [widthUnit, setWidthUnit] = useState(persistedState.widthUnit || 'Sq.Ft');
//   const [totalFloors, setTotalFloors] = useState(persistedState.totalFloors || '');
//   const [selectedFloor, setSelectedFloor] = useState(persistedState.selectedFloor || '');
//   const [ownerName, setOwnerName] = useState(persistedState.ownerName || '');
//   const [contactNumber, setContactNumber] = useState(persistedState.contactNumber || '');
//   const [emailAddress, setEmailAddress] = useState(persistedState.emailAddress || '');
//   const [socialMediaLink, setSocialMediaLink] = useState(persistedState.socialMediaLink || '');
//   const [carpetArea, setCarpetArea] = useState(persistedState.carpetArea || '');
//   const [carpetAreaUnits, setCarpetAreaUnits] = useState(persistedState.carpetAreaUnits || 'Sq.Ft');
//   const [builtUpArea, setBuiltUpArea] = useState(persistedState.builtUpArea || '');
//   const [builtUpAreaUnits, setBuiltUpAreaUnits] = useState(persistedState.builtUpAreaUnits || 'Sq.Ft');
//   const [selectedBHK, setSelectedBHK] = useState(persistedState.selectedBHK || "");
//   const [selectedFurnish, setSelectedFurnish] = useState(persistedState.selectedFurnish || "");
//   const [selectedHub, setSelectedHub] = useState(persistedState.selectedHub || '');
//   const [selectedStatus, setSelectedStatus] = useState(persistedState.selectedStatus || '');
//   const [selectedOwnership, setSelectedOwnership] = useState(persistedState.selectedOwnership || '');
//   const [floorsAvailable, setFloorsAvailable] = useState(persistedState.floorsAvailable || "");
//   const [areaSuggestions, setAreaSuggestions] = useState([]);
//   const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);
//   const [areaAnchorEl, setAreaAnchorEl] = useState(null);
//   const [selectedAreaDetails, setSelectedAreaDetails] = useState(null);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [touchedFields, setTouchedFields] = useState({});

//   const isCommercial = propertyType === 'Commercial';

//   // Property types with farmhouse in commercial
//   const [residentialPropertyTypes, setResidentialPropertyTypes] = useState([
//     { id: "apartment", name: "Apartment", icon: apartmentIcon, selected: persistedState.selectedType === "apartment" || (!persistedState.selectedType && true) },
//     { id: "independent-house", name: "Independent House", icon: independentHouseIcon, selected: persistedState.selectedType === "independent-house" },
//     { id: "pent-house", name: "Pent House", icon: pentHouseIcon, selected: persistedState.selectedType === "pent-house" },
//     { id: "studio", name: "Studio", icon: studioIcon, selected: persistedState.selectedType === "studio" },
//     { id: "plot", name: "Plot", icon: plotIcon, selected: persistedState.selectedType === "plot" },
//     { id: "agriculture-land", name: "Agriculture Land", icon: agricultureLandIcon, selected: persistedState.selectedType === "agriculture-land" },
//     { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: persistedState.selectedType === "farm-house" },
//   ]);

//   const [commercialPropertyTypes, setCommercialPropertyTypes] = useState([
//     { id: "office", name: "Office", icon: OfficeIcon, selected: persistedState.selectedType === "office" || (!persistedState.selectedType && true) },
//     { id: "showroom", name: "Showroom", icon: ShowroomIcon, selected: persistedState.selectedType === "showroom" },
//     { id: "retail-shop", name: "Retail Shop", icon: RetailShopIcon, selected: persistedState.selectedType === "retail-shop" },
//     { id: "warehouse", name: "Warehouse", icon: WarehouseIcon, selected: persistedState.selectedType === "warehouse" },
//     { id: "plot", name: "Plot", icon: CommercialPlotIcon, selected: persistedState.selectedType === "plot" },
//     { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: persistedState.selectedType === "farm-house" },
//     { id: "others", name: "Others", icon: OthersIcon, selected: persistedState.selectedType === "others" },
//   ]);

//   const [selectedPropertyType, setSelectedPropertyType] = useState(() => {
//     if (persistedState.selectedType) {
//       return persistedState.selectedType;
//     }
//     if (isCommercial) {
//       return commercialPropertyTypes.find(t => t.selected)?.id || "office";
//     }
//     return residentialPropertyTypes.find(t => t.selected)?.id || "apartment";
//   });

//   // ✅ Image handling - Fixed to preserve images properly
//   useEffect(() => {
//     const isFreshEntry = location.state?.freshEntry === true;
//     const isFromBackNavigation = location.state?.fromBackNavigation === true;
//     const preserveImages = location.state?.preserveImages !== false;

//     // ✅ Only clear if TRUE fresh entry
//     if (isFreshEntry && !isFromBackNavigation && !preserveImages) {
//       console.log('🆕 Fresh entry - clearing images');
//       setImagePreviews([]);
//       setPropertyImages([]);
//       localStorage.removeItem('propertyImagePreviews');
//       setImagesLoaded(true);
//     } else {
//       const loadImagesFromStorage = async () => {
//         const savedPreviews = localStorage.getItem('propertyImagePreviews');
//         if (savedPreviews) {
//           try {
//             const previews = JSON.parse(savedPreviews);
//             if (previews && previews.length > 0) {
//               console.log(`📸 Loading ${previews.length} images from localStorage`);
//               setImagePreviews(previews);
              
//               const filePromises = previews.map((preview, index) =>
//                 base64ToFile(preview, `property-image-${index + 1}.jpg`)
//               );
              
//               const files = await Promise.all(filePromises);
//               const validFiles = files.filter(file => file !== null);
              
//               if (validFiles.length > 0) {
//                 setPropertyImages(validFiles);
//               }
//             }
//           } catch (e) {
//             console.error('Error loading images from localStorage:', e);
//           }
//         }
//         setImagesLoaded(true);
//       };

//       if (!imagesLoaded) {
//         loadImagesFromStorage();
//       }
//     }
//   }, [location.state?.freshEntry, location.state?.fromBackNavigation, location.state?.preserveImages, imagesLoaded]);

//   // ✅ Save state to localStorage
//   useEffect(() => {
//     const stateToSave = {
//       propertyType,
//       category,
//       location: propLocation,
//       selectedType: selectedPropertyType,
//       buildingName,
//       areaName,
//       completeAddress,
//       locality,
//       landmark,
//       propertyDescription,
//       propertySize,
//       selectedUnit,
//       propertyLength,
//       lengthUnit,
//       propertyWidth,
//       widthUnit,
//       totalFloors,
//       selectedFloor,
//       ownerName,
//       contactNumber,
//       emailAddress,
//       socialMediaLink,
//       carpetArea,
//       carpetAreaUnits,
//       builtUpArea,
//       builtUpAreaUnits,
//       selectedBHK,
//       selectedFurnish,
//       selectedHub,
//       selectedStatus,
//       selectedOwnership,
//       floorsAvailable,
//       imageCount: propertyImages.length,
//       videoCount: propertyVideos.length,
//     };
//     localStorage.setItem('propertyDetailsFormState', JSON.stringify(stateToSave));
//   }, [
//     propertyType, category, propLocation, selectedPropertyType, buildingName, areaName, completeAddress, 
//     locality, landmark, propertyDescription, propertySize, selectedUnit, propertyLength, lengthUnit, 
//     propertyWidth, widthUnit, totalFloors, selectedFloor, ownerName, contactNumber, emailAddress, 
//     socialMediaLink, carpetArea, carpetAreaUnits, builtUpArea, builtUpAreaUnits, selectedBHK, 
//     selectedFurnish, selectedHub, selectedStatus, selectedOwnership, floorsAvailable, 
//     propertyImages.length, propertyVideos.length
//   ]);

//   const bhkOptions = [
//     { id: "1bhk", label: "1 BHK" },
//     { id: "2bhk", label: "2 BHK" },
//     { id: "3bhk", label: "3 BHK" },
//     { id: "4bhk", label: "4 BHK" },
//     { id: "5bhk", label: "5 BHK" },
//     { id: "6bhk", label: "6 BHK" },
//     { id: "6+bhk", label: "6+ BHK" },
//   ];

//   const furnishTypes = [
//     { id: "fully", label: "Fully Furnished" },
//     { id: "semi", label: "Semi Furnished" },
//     { id: "un", label: "Un Furnished" },
//   ];

//   const hubs = ['IT Park', 'Business Park', 'Others'];
//   const statuses = ['Ready to Occupy', 'Under Construction', 'Bare shell'];
//   const ownerships = ['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'];

//   const getSelectedPropertyType = () => {
//     if (isCommercial) {
//       return commercialPropertyTypes.find(type => type.selected) || commercialPropertyTypes[0];
//     }
//     return residentialPropertyTypes.find(type => type.selected) || residentialPropertyTypes[0];
//   };

//   const calculateProgress = () => {
//     const selectedType = getSelectedPropertyType();
//     const isPlot = selectedType?.id === 'plot';
//     const isAgricultureLand = selectedType?.id === 'agriculture-land';
//     const isFarmhouse = selectedType?.id === 'farm-house';
//     let totalFields = 0;
//     let filledFields = 0;

//     if (buildingName) filledFields++;
//     totalFields++;
//     if (areaName) filledFields++;
//     totalFields++;
//     if (completeAddress) filledFields++;
//     totalFields++;
//     if (propertyImages.length > 0 || imagePreviews.length > 0) filledFields++;
//     totalFields++;

//     if (isPlot || isAgricultureLand) {
//       if (propertySize) filledFields++;
//       totalFields++;
//       if (propertyLength) filledFields++;
//       totalFields++;
//       if (propertyWidth) filledFields++;
//       totalFields++;
//       if (isPlot) {
//         if (propertyDescription) filledFields++;
//         totalFields++;
//       }
//     } else if (isFarmhouse) {
//       if (selectedBHK) filledFields++;
//       totalFields++;
//       if (selectedFurnish) filledFields++;
//       totalFields++;
//       if (propertySize) filledFields++;
//       totalFields++;
//     } else {
//       if (!isCommercial) {
//         if (ownerName && ownerName !== 'N/A') filledFields++;
//         totalFields++;
//         if (contactNumber && contactNumber !== 'N/A') filledFields++;
//         totalFields++;
//         if (emailAddress && emailAddress !== 'N/A') filledFields++;
//         totalFields++;
//         if (selectedBHK) filledFields++;
//         totalFields++;
//         if (selectedFurnish) filledFields++;
//         totalFields++;
//       }
//       if (selectedType?.id !== 'apartment') {
//         if (propertySize) filledFields++;
//         totalFields++;
//       }
//       if (selectedType?.id === 'apartment' || selectedType?.id === 'duplex' || selectedType?.id === 'independent-house') {
//         if (carpetArea) filledFields++;
//         totalFields++;
//         if (builtUpArea) filledFields++;
//         totalFields++;
//       }
//       if (isCommercial && selectedType?.id !== 'plot' && !isFarmhouse) {
//         if (totalFloors) filledFields++;
//         totalFields++;
//         if (selectedFloor) filledFields++;
//         totalFields++;
//         if (selectedHub) filledFields++;
//         totalFields++;
//         if (selectedOwnership) filledFields++;
//         totalFields++;
//       }
//     }
//     return Math.round((filledFields / totalFields) * 100);
//   };

//   const progress = calculateProgress();

//   // Validation functions
//   const validateAlphanumeric = (text, fieldName) => {
//     if (!text || !text.trim()) return `${fieldName} is required`;
//     if (text.trim().length < 3) return `${fieldName} must be at least 3 characters`;
//     return "";
//   };

//   const validateName = (name) => {
//     if (!name || !name.trim()) return "Name is required";
//     if (name.trim().length < 3) return "Name must be at least 3 characters";
//     return "";
//   };

//   const validateNumber = (value, fieldName, min = 1, max = null) => {
//     if (!value || value === "") return `${fieldName} is required`;
//     const numValue = Number(value);
//     if (isNaN(numValue)) return `${fieldName} must be a number`;
//     if (numValue < min) return `${fieldName} must be at least ${min}`;
//     if (max !== null && numValue > max) return `${fieldName} must be less than ${max}`;
//     return "";
//   };

//   const validateEmail = (email) => {
//     if (!email || !email.trim()) return "Email is required";
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailRegex.test(email)) return "Please enter a valid email address";
//     return "";
//   };

//   const validatePhone = (phone) => {
//     if (!phone || !phone.trim()) return "Phone number is required";
//     const phoneRegex = /^[0-9]{10}$/;
//     if (!phoneRegex.test(phone)) return "Phone must be exactly 10 digits";
//     return "";
//   };

//   const validateCompleteAddress = (value) => {
//     if (!value || !value.trim()) return "Complete address is required";
//     if (value.trim().length < 10) return "Complete address must be at least 10 characters";
//     return "";
//   };

//   const validateSocialMediaLink = (link) => {
//     if (!link || !link.trim()) return "";
//     const urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
//     if (!urlRegex.test(link)) return "Please enter a valid URL";
//     return "";
//   };

//   useEffect(() => {
//     const fetchUserProfile = async () => {
//       if (!userId) {
//         setLoadingProfile(false);
//         return;
//       }
//       try {
//         setLoadingProfile(true);
//         const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
//         const data = await response.json();
//         if (data.status === "SUCCESS") {
//           setProfileData(data.result);
//           if (data.result.full_name) {
//             setOwnerName(data.result.full_name);
//           } else {
//             setOwnerName('N/A');
//           }
//           if (data.result.contact_number) {
//             setContactNumber(data.result.contact_number);
//           } else {
//             setContactNumber('N/A');
//           }
//           if (data.result.email_id) {
//             setEmailAddress(data.result.email_id);
//           } else {
//             setEmailAddress('N/A');
//           }
//         }
//       } catch (err) {
//         console.error('Error fetching profile:', err);
//       } finally {
//         setLoadingProfile(false);
//       }
//     };
//     fetchUserProfile();
//   }, [userId]);

//   const handleAreaNameChange = (e) => {
//     const value = e.target.value;
//     setAreaName(value);
//     setAreaAnchorEl(e.currentTarget);
//     if (!value) {
//       setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
//     } else if (value.trim().length < 1) {
//       setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
//     } else {
//       setErrors(prev => ({...prev, areaName: ''}));
//     }
//   };

//   const handleSelectArea = (area) => {
//     setAreaName(area.area);
//     setSelectedAreaDetails({
//       name: area.area,
//       address: area.address,
//       location: area.location
//     });
//     setAreaAnchorEl(null);
//     setShowAreaSuggestions(false);
//     setErrors(prev => ({...prev, areaName: ''}));
//   };

//   const handleAreaClickAway = () => {
//     setShowAreaSuggestions(false);
//   };

//   const fetchAreaSuggestions = async (query, city) => {
//     if (query.length < 1 || !city) return;
//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
//       const data = await response.json();
//       if (data.success && data.areas && data.areas.length > 0) {
//         const transformedAreas = data.areas.map(area => ({
//           area: area.name,
//           address: area.address,
//           location: area.location
//         }));
//         setAreaSuggestions(transformedAreas);
//         setShowAreaSuggestions(true);
//       } else {
//         setAreaSuggestions([]);
//         setShowAreaSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   };

//   useEffect(() => {
//     if (areaName.trim().length > 0 && location.state?.location) {
//       fetchAreaSuggestions(areaName, location.state.location);
//     } else {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   }, [areaName, location.state?.location]);

//   const handleImageUpload = (event) => {
//     const files = event.target.files;
//     if (!files || files.length === 0) return;
//     if (files.length > 10) {
//       alert("You can only upload up to 10 images");
//       return;
//     }

//     const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
//     if (validFiles.length !== files.length) {
//       alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
//       return;
//     }

//     const newPreviews = [];
//     const fileProcessPromises = validFiles.map(file => {
//       return new Promise((resolve) => {
//         const reader = new FileReader();
//         reader.onload = (e) => {
//           newPreviews.push(e.target.result);
//           resolve();
//         };
//         reader.onerror = () => {
//           console.error(`Failed to read file: ${file.name}`);
//           resolve();
//         };
//         reader.readAsDataURL(file);
//       });
//     });

//     Promise.all(fileProcessPromises).then(() => {
//       const updatedPreviews = [...imagePreviews, ...newPreviews];
//       const updatedFiles = [...propertyImages, ...validFiles];
//       setImagePreviews(updatedPreviews);
//       setPropertyImages(updatedFiles);
//       localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
//     });
//   };

//   const handlePropertyTypeSelect = (typeId) => {
//     const previousType = selectedPropertyType;
//     setSelectedPropertyType(typeId);

//     if (previousType !== typeId) {
//       const isPlot = typeId === 'plot';
//       const isAgricultureLand = typeId === 'agriculture-land';
//       const isFarmhouse = typeId === 'farm-house';
//       const wasPlot = previousType === 'plot';
//       const wasAgricultureLand = previousType === 'agriculture-land';
//       const wasFarmhouse = previousType === 'farm-house';

//       if ((isPlot || isAgricultureLand) && (!wasPlot && !wasAgricultureLand && !wasFarmhouse)) {
//         setSelectedBHK('');
//         setSelectedFurnish('');
//         setCarpetArea('');
//         setBuiltUpArea('');
//         setOwnerName('');
//         setContactNumber('');
//         setEmailAddress('');
//         setSocialMediaLink('');
//         setTotalFloors('');
//         setSelectedFloor('');
//       }
//       else if ((!isPlot && !isAgricultureLand && !isFarmhouse) && (wasPlot || wasAgricultureLand)) {
//         setPropertyDescription('');
//         setPropertyLength('');
//         setPropertyWidth('');
//         setLandmark('');
//       }
//       else if (isFarmhouse && (wasPlot || wasAgricultureLand)) {
//         setPropertyDescription('');
//         setPropertyLength('');
//         setPropertyWidth('');
//         setLandmark('');
//       }
//       setErrors({});
//     }

//     if (isCommercial) {
//       const updatedTypes = commercialPropertyTypes.map(type => ({
//         ...type,
//         selected: type.id === typeId
//       }));
//       setCommercialPropertyTypes(updatedTypes);
//     } else {
//       const updatedTypes = residentialPropertyTypes.map(type => ({
//         ...type,
//         selected: type.id === typeId
//       }));
//       setResidentialPropertyTypes(updatedTypes);
//     }
//   };

//   const handleBack = () => {
//     navigate('/add-new-property', { 
//       state: { 
//         propertyType: propertyType, 
//         category: category, 
//         location: location.state?.location || propLocation || localStorage.getItem('propertyLocation') || '', 
//         asset_type: getSelectedPropertyType()?.name || '', 
//         selectedType: getSelectedPropertyType()?.id || '', 
//         fromPropertyDetails: true,
//         preserveImages: true,
//         fromBackNavigation: true,
//         freshEntry: false,
//       } 
//     });
//   };

//  const handleNext = () => {
//   let selectedType = null;
//   if (isCommercial) {
//     selectedType = commercialPropertyTypes.find(type => type.selected);
//   } else {
//     selectedType = residentialPropertyTypes.find(type => type.selected);
//   }

//   const isPlot = selectedType?.id === 'plot';
//   const isAgricultureLand = selectedType?.id === 'agriculture-land';
//   const isFarmhouse = selectedType?.id === 'farm-house'; // ✅ Use exact ID match

//   let validationErrors = {
//     buildingName: validateAlphanumeric(buildingName, "Building name"),
//     areaName: validateName(areaName),
//     ...(selectedType?.id !== 'apartment' && { propertySize: validateNumber(propertySize, "Property size") })
//   };

//   if (isPlot || isAgricultureLand) {
//     validationErrors = {
//       ...validationErrors,
//       completeAddress: validateCompleteAddress(completeAddress),
//     };
//     if (isPlot) {
//       validationErrors.propertyDescription = validateName(propertyDescription);
//     }
//   } else if (selectedType?.id === 'independent-house' || selectedType?.id === 'apartment' || selectedType?.id === 'duplex') {
//     validationErrors.completeAddress = validateCompleteAddress(completeAddress);
//     validationErrors.carpetArea = validateNumber(carpetArea, "Carpet area");
//     validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
//     if (!isCommercial) {
//       validationErrors = {
//         ...validationErrors,
//         ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
//         contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
//         emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
//         bhk: selectedBHK ? '' : 'Please select BHK',
//         furnish: selectedFurnish ? '' : 'Please select furnish type',
//       };
//     }
//   } else if (isFarmhouse) {
//     validationErrors.completeAddress = validateCompleteAddress(completeAddress);
//     validationErrors.propertySize = validateNumber(propertySize, "Property size");
//     validationErrors.bhk = selectedBHK ? '' : 'Please select BHK';
//     validationErrors.furnish = selectedFurnish ? '' : 'Please select furnish type';
//   } else if (isCommercial && !isPlot && !isFarmhouse) {
//     validationErrors = {
//       ...validationErrors,
//       totalFloors: validateNumber(totalFloors, "Total floors", 1, 100),
//       selectedFloor: selectedFloor ? '' : 'Please select floor',
//       propertySize: validateNumber(propertySize, "Property size"),
//     };
//   }

//   if (socialMediaLink && socialMediaLink.trim()) {
//     validationErrors.socialMediaLink = validateSocialMediaLink(socialMediaLink);
//   }

//   setErrors(validationErrors);
//   const hasErrors = Object.values(validationErrors).some(error => error);

//   if (hasErrors) {
//     const firstErrorField = Object.keys(validationErrors).find(key => validationErrors[key]);
//     if (firstErrorField) {
//       const element = document.getElementById(firstErrorField);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//         element.focus();
//       }
//     }
//     return;
//   }

//   const propertyDetails = {
//     propertyType: isCommercial ? 'Commercial' : 'Residential',
//     category: category,
//     location: location.state?.location || propLocation || '',
//     asset_type: selectedType?.name || '',
//     selectedType: selectedType?.id || '',
//     property_name: buildingName || '',
//     buildingName: buildingName || '',
//     area_name: areaName || '',
//     areaName: areaName || '',
//     landmark: landmark || '',
//     description: (isPlot ? propertyDescription : '') || '',
//     propertyDescription: propertyDescription || '',
//     bhk: (!isPlot && !isAgricultureLand && !isCommercial) || isFarmhouse ? (selectedBHK || '') : '',
//     furnish_type: (!isPlot && !isAgricultureLand && !isCommercial) || isFarmhouse ? (selectedFurnish || '') : '',
//     full_address: completeAddress || '',
//     completeAddress: completeAddress || '',
//     locality: (!isPlot && !isAgricultureLand) ? (locality || '') : null,
//     carpet_area: (selectedType?.id === 'apartment' || selectedType?.id === 'duplex' || selectedType?.id === 'independent-house') ? (carpetArea || '') : '',
//     carpet_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'duplex' || selectedType?.id === 'independent-house') ? (carpetAreaUnits || '') : '',
//     built_up_area: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpArea || '') : '',
//     built_up_area_units: (selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') ? (builtUpAreaUnits || '') : '',
//     property_size: propertySize || '',
//     propertySize: propertySize || '',
//     property_size_units: selectedUnit || 'sq.yards',
//     selectedUnit: selectedUnit || 'sq.yards',
//     length: propertyLength || '',
//     width: propertyWidth || '',
//     propertyLength: propertyLength || '',
//     propertyWidth: propertyWidth || '',
//     lengthUnit: lengthUnit || 'Sq.Ft',
//     widthUnit: widthUnit || 'Sq.Ft',
//     total_floors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
//     totalFloors: (!isPlot && !isAgricultureLand) ? (totalFloors || '') : '',
//     select_floor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
//     selectedFloor: (!isPlot && !isAgricultureLand) ? (selectedFloor || '') : '',
//     propertyImages: propertyImages || [],
//     propertyVideos: propertyVideos || [],
//     social_media_link: socialMediaLink?.trim() || '',
//     socialMediaLink: socialMediaLink?.trim() || '',
//     ownerName: (!isPlot && !isAgricultureLand && !isCommercial) ? (ownerName || '') : '',
//     contactNumber: (!isPlot && !isAgricultureLand && !isCommercial) ? (contactNumber || '') : '',
//     emailAddress: (!isPlot && !isAgricultureLand && !isCommercial) ? (emailAddress || '') : '',
//     freshEntry: false,
//     fromPropertyDetails: true,
//     preserveImages: true,
//   };

//   if (isCommercial) {
//     propertyDetails.commercial_catgory = category.toLowerCase() === 'sell' ? 'sale' : 'rent';
//     propertyDetails.commercial_asset_type = selectedType?.name || '';
//     propertyDetails.hub = selectedHub || '';
//     propertyDetails.ownership = selectedOwnership || '';
//     propertyDetails.floors_available = floorsAvailable || '';
//   }

//   // ✅ FIXED: Correct amenities logic for commercial farmhouse
//   const shouldShowAmenities = (isFarmhouse || !isCommercial) && !isPlot && !isAgricultureLand;

//   console.log('🔍 Navigation Debug:', {
//     isCommercial,
//     isFarmhouse,
//     isPlot,
//     isAgricultureLand,
//     shouldShowAmenities,
//     selectedTypeId: selectedType?.id,
//     selectedTypeName: selectedType?.name
//   });

//   if (shouldShowAmenities) {
//     navigate('/amenities', { state: propertyDetails });
//   } else {
//     localStorage.removeItem('amenities_society');
//     localStorage.removeItem('amenities_furnishing');
//     localStorage.removeItem('amenities_other');

//     if (category === 'Rent') {
//       navigate('/rent-details', { state: propertyDetails });
//     } else if (category === 'Sell') {
//       navigate('/price-details', { state: propertyDetails });
//     }
//   }
// };

//   useEffect(() => {
//     if (isCommercial) {
//       if (!selectedHub) setSelectedHub('Business Park');
//       if (!selectedStatus) setSelectedStatus('Ready to Occupy');
//       if (!selectedOwnership) setSelectedOwnership('Freehold');
//     }
//   }, [isCommercial]);

//   const renderForm = () => {
//     const selectedType = getSelectedPropertyType();
//     const isPlot = selectedType?.id === 'plot';
//     const isAgricultureLand = selectedType?.id === 'agriculture-land';
//     const isFarmhouse = selectedType?.id === 'farm-house';

//     return (
//       <Box>
//         {/* Property Type & Upload Images */}
//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           <Grid item xs={12} sm="auto">
//             <Box sx={{ width: '410px', maxWidth: '100%' }}>
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                 Property Type <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
//               <FormControl fullWidth size="small">
//                 <Select
//                   value={selectedPropertyType}
//                   onChange={(e) => handlePropertyTypeSelect(e.target.value)}
//                   displayEmpty
//                   sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   renderValue={(selected) => {
//                     const propertyTypes = isCommercial ? commercialPropertyTypes : residentialPropertyTypes;
//                     const selectedTypeObj = propertyTypes.find(type => type.id === selected);
//                     if (!selectedTypeObj) {
//                       return <em style={{ color: '#999' }}>Select Property Type</em>;
//                     }
//                     return (
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                         <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
//                           {selectedTypeObj.name}
//                         </Typography>
//                       </Box>
//                     );
//                   }}
//                 >
//                   {(isCommercial ? commercialPropertyTypes : residentialPropertyTypes).map((type) => (
//                     <MenuItem key={type.id} value={type.id}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
//                         {type.name}
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>
//           </Grid>

//           <Grid item xs={12} sm="auto">
//             <Box sx={{ width: '410px', maxWidth: '100%' }}>
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                 Upload Images
//               </Typography>
//               <Box
//                 sx={{
//                   height: 36,
//                   border: '2px dashed #d0d0d0',
//                   borderRadius: 1.5,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   cursor: 'pointer',
//                   transition: 'all 0.2s ease',
//                   '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
//                 }}
//                 onClick={() => document.getElementById('property-images').click()}
//               >
//                 <input
//                   type="file"
//                   id="property-images"
//                   multiple
//                   accept="image/*"
//                   style={{ display: 'none' }}
//                   onChange={handleImageUpload}
//                 />
//                 <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
//                   Upload (Max 10)
//                 </Typography>
//               </Box>
//             </Box>
//           </Grid>
//         </Grid>

//         {/* Display uploaded images */}
//         {imagePreviews && imagePreviews.length > 0 && (
//           <Box sx={{ mb: 3 }}>
//             <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
//               {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
//             </Typography>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
//               {imagePreviews.map((preview, index) => (
//                 <Box
//                   key={`img-preview-${index}`}
//                   sx={{
//                     position: 'relative',
//                     width: '100px',
//                     height: '100px',
//                     borderRadius: 1.5,
//                     overflow: 'hidden',
//                     border: '2px solid #e0e0e0',
//                     cursor: 'pointer',
//                     flexShrink: 0,
//                     '&:hover': { borderColor: '#1976d2' }
//                   }}
//                   onClick={() => {
//                     setSelectedImageIndex(index);
//                     setPreviewOpen(true);
//                   }}
//                 >
//                   <Box
//                     component="img"
//                     src={preview}
//                     alt={`Preview ${index + 1}`}
//                     sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                   />
//                   <IconButton
//                     size="small"
//                     sx={{
//                       position: 'absolute',
//                       top: -8,
//                       right: -8,
//                       bgcolor: '#ff4444',
//                       color: 'white',
//                       width: 24,
//                       height: 24,
//                       fontSize: '14px',
//                       '&:hover': { bgcolor: '#cc0000' }
//                     }}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       const newPreviews = [...imagePreviews];
//                       const newFiles = [...propertyImages];
//                       newPreviews.splice(index, 1);
//                       newFiles.splice(index, 1);
//                       setImagePreviews(newPreviews);
//                       setPropertyImages(newFiles);
//                       if (newPreviews.length > 0) {
//                         localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
//                       } else {
//                         localStorage.removeItem('propertyImagePreviews');
//                       }
//                     }}
//                   >
//                     ×
//                   </IconButton>
//                 </Box>
//               ))}
//             </Box>
//           </Box>
//         )}

//         {/* Building Name & Area Name */}
//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           <Grid item xs={12} sm="auto">
//             <Box sx={{ width: '410px', maxWidth: '100%' }}>
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                 Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
//               <TextField
//                 id="buildingName"
//                 fullWidth
//                 size="small"
//                 placeholder="Enter building name"
//                 value={buildingName}
//                 onChange={(e) => {
//                   setBuildingName(e.target.value);
//                   setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
//                 }}
//                 error={!!errors.buildingName}
//                 helperText={errors.buildingName}
//                 sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//               />
//             </Box>
//           </Grid>

//           <Grid item xs={12} sm="auto">
//             <Box sx={{ width: '410px', maxWidth: '100%' }}>
//               <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                 Area Name <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
//               <ClickAwayListener onClickAway={handleAreaClickAway}>
//                 <Box sx={{ position: 'relative' }}>
//                   <TextField
//                     id="areaName"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter area name"
//                     value={areaName}
//                     onChange={handleAreaNameChange}
//                     error={!!errors.areaName}
//                     helperText={errors.areaName}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                   {showAreaSuggestions && areaSuggestions.length > 0 && (
//                     <Popper
//                       open={showAreaSuggestions}
//                       anchorEl={areaAnchorEl}
//                       placement="bottom-start"
//                       transition
//                       style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
//                     >
//                       {({ TransitionProps }) => (
//                         <Grow {...TransitionProps} timeout={200}>
//                           <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
//                             <List dense>
//                               {areaSuggestions.map((area, index) => (
//                                 <ListItem
//                                   key={index}
//                                   button
//                                   onClick={() => handleSelectArea(area)}
//                                   sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
//                                 >
//                                   <ListItemText
//                                     primary={area.area}
//                                     primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
//                                   />
//                                 </ListItem>
//                               ))}
//                             </List>
//                           </Paper>
//                         </Grow>
//                       )}
//                     </Popper>
//                   )}
//                 </Box>
//               </ClickAwayListener>
//             </Box>
//           </Grid>
//         </Grid>

//        {/* Complete Address */}
// {((!isCommercial || isPlot) || isFarmhouse) && (
//   <Box sx={{ mb: 3 }}>
//     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//       Complete Address <span style={{ color: '#d32f2f' }}>*</span>
//     </Typography>
//     <TextField
//       id="completeAddress"
//       fullWidth
//       size="small"
//       multiline
//       rows={2}
//       placeholder="Enter complete address"
//       value={completeAddress}
//       onChange={(e) => {
//         setCompleteAddress(e.target.value);
//         setErrors(prev => ({...prev, completeAddress: validateCompleteAddress(e.target.value)}));
//       }}
//       error={!!errors.completeAddress}
//       helperText={errors.completeAddress}
//       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//     />
//   </Box>
// )}

//         {/* Plot & Agriculture Land Specific Fields */}
//         {(isPlot || isAgricultureLand) && (
//           <>
//             {isPlot && (
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Description <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       id="propertyDescription"
//                       fullWidth
//                       size="small"
//                       multiline
//                       rows={3}
//                       placeholder="Short description"
//                       value={propertyDescription}
//                       onChange={(e) => {
//                         setPropertyDescription(e.target.value);
//                         setErrors(prev => ({...prev, propertyDescription: validateName(e.target.value)}));
//                       }}
//                       error={!!errors.propertyDescription}
//                       helperText={errors.propertyDescription}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>
//                 </Grid>
//               </Grid>
//             )}
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//       <Grid item xs={12} sm="auto">
//         <Box sx={{ width: '410px', maxWidth: '100%' }}>
//           <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//             Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//           </Typography>
//           <TextField
//             id="socialMediaLink"
//             fullWidth
//             size="small"
//             type="url"
//             placeholder="Paste social media link"
//             value={socialMediaLink}
//             onChange={(e) => {
//               setSocialMediaLink(e.target.value);
//               if (e.target.value) {
//                 setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//               } else {
//                 setErrors(prev => ({...prev, socialMediaLink: ''}));
//               }
//             }}
//             error={!!errors.socialMediaLink}
//             helperText={errors.socialMediaLink}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//           />
//         </Box>
//       </Grid>
//     </Grid>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <Grid container spacing={1}>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '180px' }}>
//                         <TextField
//                           id="propertySize"
//                           fullWidth
//                           size="small"
//                           placeholder="Enter size"
//                           value={propertySize}
//                           onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '');
//                             setPropertySize(value);
//                             setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                           }}
//                           error={!!errors.propertySize}
//                           helperText={errors.propertySize}
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '80px' }}>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             value={selectedUnit}
//                             onChange={(e) => setSelectedUnit(e.target.value)}
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                           >
//                             <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                             <MenuItem value="acres">Acres</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>

//               <Grid item xs={6} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                   </Typography>
//                   <Grid container spacing={0.5}>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '180px' }}>
//                         <TextField
//                           id="propertyLength"
//                           fullWidth
//                           size="small"
//                           placeholder="Length"
//                           value={propertyLength}
//                           onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '');
//                             setPropertyLength(value);
//                           }}
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '80px' }}>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             value={lengthUnit}
//                             onChange={(e) => setLengthUnit(e.target.value)}
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '11px' }}
//                           >
//                             <MenuItem value="Sq.Ft">Sq.Ft</MenuItem>
//                             <MenuItem value="Yards">Yards</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>

//               <Grid item xs={6} sm="auto">
//                 <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//                   </Typography>
//                   <Grid container spacing={0.5}>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '180px' }}>
//                         <TextField
//                           id="propertyWidth"
//                           fullWidth
//                           size="small"
//                           placeholder="Width"
//                           value={propertyWidth}
//                           onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '');
//                             setPropertyWidth(value);
//                           }}
//                           sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                         />
//                       </Box>
//                     </Grid>
//                     <Grid item xs="auto">
//                       <Box sx={{ width: '80px' }}>
//                         <FormControl fullWidth size="small">
//                           <Select
//                             value={widthUnit}
//                             onChange={(e) => setWidthUnit(e.target.value)}
//                             sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '11px' }}
//                           >
//                             <MenuItem value="Sq.Ft">Sq.Ft</MenuItem>
                            
//                             <MenuItem value="Yards">Yards</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>
//             </Grid>

//             {isAgricultureLand && (
//               <Box sx={{ mb: 3 }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Landmark (Optional)
//                 </Typography>
//                 <Box sx={{ width: '410px', maxWidth: '100%' }}>
//                   <TextField
//                     id="landmark"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter nearby landmark"
//                     value={landmark}
//                     onChange={(e) => setLandmark(e.target.value)}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Box>
//               </Box>
//             )}
//           </>
//         )}

//         {/* Farmhouse Fields */}
//         {isFarmhouse && (
//           <>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm="auto">
//         <Box sx={{ width: '300px', maxWidth: '100%' }}>
//           <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//             Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//           </Typography>
//           <TextField
//             id="socialMediaLink"
//             fullWidth
//             size="small"
//             type="url"
//             placeholder="Paste social media link"
//             value={socialMediaLink}
//             onChange={(e) => {
//               setSocialMediaLink(e.target.value);
//               if (e.target.value) {
//                 setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//               } else {
//                 setErrors(prev => ({...prev, socialMediaLink: ''}));
//               }
//             }}
//             error={!!errors.socialMediaLink}
//             helperText={errors.socialMediaLink}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//           />
//         </Box>
//       </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '180px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     BHK <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.bhk}>
//                     <Select
//                       value={selectedBHK}
//                       onChange={(e) => {
//                         setSelectedBHK(e.target.value);
//                         setErrors({...errors, bhk: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                       {bhkOptions.map((option) => (
//                         <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '230px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.furnish}>
//                     <Select
//                       value={selectedFurnish}
//                       onChange={(e) => {
//                         setSelectedFurnish(e.target.value);
//                         setErrors({...errors, furnish: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                       {furnishTypes.map((type) => (
//                         <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>

//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={8}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//                            </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Unit
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedUnit}
//                     onChange={(e) => setSelectedUnit(e.target.value)}
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="sq.ft">Sq. ft</MenuItem>
//                     <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//           </>
//         )}

//         {/* NON-PLOT & NON-AGRICULTURE LAND RESIDENTIAL FIELDS (Excluding Farmhouse) */}
//         {!isPlot && !isAgricultureLand && !isCommercial && !isFarmhouse && (
//           <>
//             {/* Social Media Link, BHK, Furnish Type */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm="auto">
//         <Box sx={{ width: '280px', maxWidth: '100%' }}>
//           <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//             Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//           </Typography>
//           <TextField
//             id="socialMediaLink"
//             fullWidth
//             size="small"
//             type="url"
//             placeholder="Paste social media link"
//             value={socialMediaLink}
//             onChange={(e) => {
//               setSocialMediaLink(e.target.value);
//               if (e.target.value) {
//                 setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//               } else {
//                 setErrors(prev => ({...prev, socialMediaLink: ''}));
//               }
//             }}
//             error={!!errors.socialMediaLink}
//             helperText={errors.socialMediaLink}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//           />
//         </Box>
//       </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     BHK <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.bhk}>
//                     <Select
//                       value={selectedBHK}
//                       onChange={(e) => {
//                         setSelectedBHK(e.target.value);
//                         setErrors({...errors, bhk: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
//                       {bhkOptions.map((option) => (
//                         <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Box sx={{ width: '210px', maxWidth: '100%' }}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <FormControl fullWidth size="small" error={!!errors.furnish}>
//                     <Select
//                       value={selectedFurnish}
//                       onChange={(e) => {
//                         setSelectedFurnish(e.target.value);
//                         setErrors({...errors, furnish: ''});
//                       }}
//                       displayEmpty
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
//                       {furnishTypes.map((type) => (
//                         <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
//                       ))}
//                     </Select>
//                     {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Contact Information */}
//             <Box sx={{ mb: 3 }}>
//               <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//                 Contact Information <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                       Owner Name
//                     </Typography>
//                     <TextField
//                       id="ownerName"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter owner name"
//                       value={ownerName}
//                       onChange={(e) => {
//                         setOwnerName(e.target.value);
//                         if (e.target.value !== 'N/A') {
//                           setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
//                         }
//                       }}
//                       disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
//                       error={!!errors.ownerName}
//                       helperText={errors.ownerName}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                           backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
//                         }
//                       }}
//                     />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                       Contact Number
//                     </Typography>
//                     <TextField
//                       id="contactNumber"
//                       fullWidth
//                       size="small"
//                       type="tel"
//                       placeholder="Enter contact number"
//                       value={contactNumber}
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         if (value === 'N/A' || value === '') {
//                           setContactNumber(value);
//                         } else {
//                           const numericValue = value.replace(/\D/g, '').slice(0, 10);
//                           setContactNumber(numericValue);
//                           if (numericValue !== 'N/A') {
//                             setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
//                           }
//                         }
//                       }}
//                       disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
//                       error={!!errors.contactNumber}
//                       helperText={errors.contactNumber}
//                       inputProps={{ maxLength: 10 }}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                           backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
//                         }
//                       }}
//                     />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
//                       Email Address
//                     </Typography>
//                     <TextField
//                       id="emailAddress"
//                       fullWidth
//                       size="small"
//                       type="email"
//                       placeholder="Enter email address"
//                       value={emailAddress}
//                       onChange={(e) => {
//                         setEmailAddress(e.target.value);
//                         if (e.target.value !== 'N/A') {
//                           setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
//                         }
//                       }}
//                       disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
//                       error={!!errors.emailAddress}
//                       helperText={errors.emailAddress}
//                       sx={{
//                         '& .MuiOutlinedInput-root': {
//                           borderRadius: 1.5,
//                           fontFamily: 'Outfit',
//                           fontSize: '13px',
//                           backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
//                         }
//                       }}
//                     />
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Carpet Area, Built-up Area (for Apartment, Independent House, Duplex) */}
//             {(selectedType?.id === 'apartment' || selectedType?.id === 'independent-house' || selectedType?.id === 'duplex') && (
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       id="carpetArea"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter carpet area"
//                       value={carpetArea}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setCarpetArea(value);
//                         setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
//                       }}
//                       error={!!errors.carpetArea}
//                       helperText={errors.carpetArea}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       InputProps={{
//                         endAdornment: <Typography sx={{ fontSize: '13px', color: '#666', fontFamily: 'Outfit', ml: 1 }}>Sq.Yards</Typography>
//                       }}
//                     />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '270px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
//                     </Typography>
//                     <TextField
//                       id="builtUpArea"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter built-up area"
//                       value={builtUpArea}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setBuiltUpArea(value);
//                         setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
//                       }}
//                       error={!!errors.builtUpArea}
//                       helperText={errors.builtUpArea}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                       InputProps={{
//                         endAdornment: <Typography sx={{ fontSize: '13px', color: '#666', fontFamily: 'Outfit', ml: 1 }}>Sq.Yards</Typography>
//                       }}
//                     />
//                   </Box>
//                 </Grid>
//               </Grid>
//             )}

//             {/* Property Size for non-apartment residential */}
//             {selectedType?.id !== 'apartment' && (
//               <Grid container spacing={2} sx={{ mb: 3 }}>
//                 <Grid item xs={12} sm={8}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                   </Typography>
//                   <TextField
//                     id="propertySize"
//                     fullWidth
//                     size="small"
//                     placeholder="Enter property size"
//                     value={propertySize}
//                     onChange={(e) => {
//                       const value = e.target.value.replace(/[^0-9]/g, '');
//                       setPropertySize(value);
//                       setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                     }}
//                     error={!!errors.propertySize}
//                     helperText={errors.propertySize}
//                     sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={4}>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                     Unit
//                   </Typography>
//                   <FormControl fullWidth size="small">
//                     <Select
//                       value={selectedUnit}
//                       onChange={(e) => setSelectedUnit(e.target.value)}
//                       sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                     >
//                       <MenuItem value="sq.ft">Sq. ft</MenuItem>
//                       <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             )}
//           </>
//         )}

//         {/* Commercial Fields (NOT Plot, NOT Farmhouse) */}
//         {isCommercial && !isPlot && !isFarmhouse && (
//           <>
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//       <Grid item xs={12} sm="auto">
//         <Box sx={{ width: '410px', maxWidth: '100%' }}>
//           <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//             Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
//           </Typography>
//           <TextField
//             id="socialMediaLink"
//             fullWidth
//             size="small"
//             type="url"
//             placeholder="Paste social media link"
//             value={socialMediaLink}
//             onChange={(e) => {
//               setSocialMediaLink(e.target.value);
//               if (e.target.value) {
//                 setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
//               } else {
//                 setErrors(prev => ({...prev, socialMediaLink: ''}));
//               }
//             }}
//             error={!!errors.socialMediaLink}
//             helperText={errors.socialMediaLink}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
//                 </InputAdornment>
//               ),
//             }}
//             sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//           />
//         </Box>
//       </Grid>
//     </Grid>
//             {/* Property Size - Full Width */}
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={8}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Property Size <span style={{ color: '#d32f2f' }}>*</span>
//                 </Typography>
//                 <TextField
//                   id="propertySize"
//                   fullWidth
//                   size="small"
//                   placeholder="Enter property size"
//                   value={propertySize}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^0-9]/g, '');
//                     setPropertySize(value);
//                     setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
//                   }}
//                   error={!!errors.propertySize}
//                   helperText={errors.propertySize}
//                   sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                   Unit
//                 </Typography>
//                 <FormControl fullWidth size="small">
//                   <Select
//                     value={selectedUnit}
//                     onChange={(e) => setSelectedUnit(e.target.value)}
//                     sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                   >
//                     <MenuItem value="sq.ft">Sq. ft</MenuItem>
//                     <MenuItem value="sq.yards">Sq. yards</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             {/* Available Floors Section */}
//             <Box sx={{ mb: 3 }}>
//               <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
//                 Available Floors <span style={{ color: '#d32f2f' }}>*</span>
//               </Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Total Floors
//                     </Typography>
//                     <TextField
//                       id="totalFloors"
//                       fullWidth
//                       size="small"
//                       placeholder="Enter total floors"
//                       value={totalFloors}
//                       onChange={(e) => {
//                         const value = e.target.value.replace(/[^0-9]/g, '');
//                         setTotalFloors(value);
//                         setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
//                       }}
//                       error={!!errors.totalFloors}
//                       helperText={errors.totalFloors}
//                       sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
//                     />
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '185px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Select Floor
//                     </Typography>
//                     <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
//                       <Select
//                         id="selectedFloor"
//                         value={selectedFloor}
//                         onChange={(e) => {
//                           setSelectedFloor(e.target.value);
//                           setErrors({...errors, selectedFloor: ''});
//                         }}
//                         displayEmpty
//                         sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                       >
//                         <MenuItem value="" disabled>Select Floor</MenuItem>
//                         {[...Array(20)].map((_, i) => (
//                           <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
//                             {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
//                           </MenuItem>
//                         ))}
//                       </Select>
//                       {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
//                     </FormControl>
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '200px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Ownership
//                     </Typography>
//                     <FormControl fullWidth size="small">
//                       <Select
//                         value={selectedOwnership}
//                         onChange={(e) => setSelectedOwnership(e.target.value)}
//                         displayEmpty
//                         sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                       >
//                         <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
//                         {ownerships.map((own) => (
//                           <MenuItem key={own} value={own}>{own}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sm="auto">
//                   <Box sx={{ width: '200px', maxWidth: '100%' }}>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
//                       Hub
//                     </Typography>
//                     <FormControl fullWidth size="small">
//                       <Select
//                         value={selectedHub}
//                         onChange={(e) => setSelectedHub(e.target.value)}
//                         displayEmpty
//                         sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
//                       >
//                         <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
//                         {hubs.map((hub) => (
//                           <MenuItem key={hub} value={hub}>{hub}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//           </>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <PostAccess
//       currentStep={1}
//       category={category}
//       propertyType={propertyType}
//       assetType={selectedPropertyType}
//     >
//       <Paper
//         elevation={0}
//         sx={{
//           flex: 1,
//           maxWidth: { xs: '100%', md: '900px' },
//           p: { xs: 2.5, sm: 3, md: 3.5 },
//           backgroundColor: '#ffffff',
//           borderRadius: 2,
//           border: '1px solid #e0e0e0',
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: 'Outfit',
//             fontWeight: 600,
//             mb: 0.5,
//             fontSize: { xs: '18px', md: '22px' },
//           }}
//         >
//           Add Property Details
//         </Typography>

//         <Typography
//           sx={{
//             fontFamily: 'Outfit',
//             fontSize: '13px',
//             color: '#666',
//             mb: 3,
//           }}
//         >
//           {progress}% <span style={{ color: progress > 75 ? '#4caf50' : progress > 50 ? '#ff9800' : '#2196f3' }}>●●●○○</span>
//         </Typography>

//         {renderForm()}

//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             gap: 2,
//             mt: 4,
//           }}
//         >
//           <Button
//             variant="outlined"
//             onClick={handleBack}
//             sx={{
//               px: 3,
//               py: 1,
//               borderRadius: 1.5,
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               fontSize: '13px',
//               color: '#666',
//               borderColor: '#e0e0e0',
//               minWidth: { xs: '80px', sm: '100px' },
//             }}
//           >
//             Back
//           </Button>

//           <Button
//             variant="contained"
//             onClick={handleNext}
//             sx={{
//               px: 3,
//               py: 1,
//               borderRadius: 1.5,
//               textTransform: 'none',
//               fontFamily: 'Outfit',
//               fontSize: '13px',
//               backgroundColor: '#1976d2',
//               minWidth: { xs: '80px', sm: '100px' },
//               '&:hover': {
//                 backgroundColor: '#1565c0',
//               },
//             }}
//           >
//             Next
//           </Button>
//         </Box>
//       </Paper>

//       {/* Image Preview Dialog */}
//       {imagePreviews.length > 0 && (
//         <Dialog
//           open={previewOpen}
//           onClose={() => setPreviewOpen(false)}
//           maxWidth="md"
//           fullWidth
//           sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
//         >
//           <DialogContent sx={{ p: 0, position: 'relative' }}>
//             <Box
//               component="img"
//               src={imagePreviews[selectedImageIndex]}
//               alt={`Image ${selectedImageIndex + 1}`}
//               sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
//             />
//             <IconButton
//               onClick={() => setPreviewOpen(false)}
//               sx={{
//                 position: 'absolute',
//                 top: 8,
//                 right: 8,
//                 bgcolor: 'rgba(255, 255, 255, 0.3)',
//                 color: 'white',
//                 '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//               }}
//             >
//               <CloseIcon />
//             </IconButton>
//             {imagePreviews.length > 1 && (
//               <>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
//                   sx={{
//                     position: 'absolute',
//                     left: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ‹
//                 </IconButton>
//                 <IconButton
//                   onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
//                   sx={{
//                     position: 'absolute',
//                     right: 8,
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     bgcolor: 'rgba(255, 255, 255, 0.3)',
//                     color: 'white',
//                     '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
//                   }}
//                 >
//                   ›
//                 </IconButton>
//                 <Box
//                   sx={{
//                     position: 'absolute',
//                     bottom: 16,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     bgcolor: 'rgba(0, 0, 0, 0.7)',
//                     color: 'white',
//                     px: 2,
//                     py: 1,
//                     borderRadius: '16px',
//                     fontSize: '14px',
//                     fontFamily: 'Outfit'
//                   }}
//                 >
//                   {selectedImageIndex + 1} / {imagePreviews.length}
//                 </Box>
//               </>
//             )}
//           </DialogContent>
//         </Dialog>
//       )}
//     </PostAccess>
//   );
// };

// export default PropertyDetails;


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemText,
  Popper,
  Grow,
  ClickAwayListener,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Dialog,
  DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUpload from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import { useSelector } from 'react-redux';
import { selectUser } from '../Commonlibs/userSlice';
import PostAccess from './PostAccess';

// Import icons
import apartmentIcon from "../assets/appsell.png";
import independentHouseIcon from "../assets/apphouse.png";
import pentHouseIcon from "../assets/apppent.png";
import villaIcon from "../assets/appvilla.png";
import studioIcon from "../assets/appstudio.png";
import plotIcon from "../assets/appplot.png";
import agricultureLandIcon from "../assets/appagri.png";
import farmHouseIcon from "../assets/appfarm.png";
import OfficeIcon from '../assets/officecomm.png';
import ShowroomIcon from '../assets/showcomm.png';
import RetailShopIcon from '../assets/retailcomm.png';
import WarehouseIcon from '../assets/ware comm.png';
import CommercialPlotIcon from '../assets/plotcomm.png';

const base64ToFile = async (base64String, filename) => {
  try {
    const response = await fetch(base64String);
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  } catch (error) {
    console.error('Error converting base64 to file:', error);
    return null;
  }
};

const PropertyDetails = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const {
    propertyType = 'Residential',
    category = 'Sell',
    location: propLocation = ''
  } = location.state || {};

  const user = useSelector(selectUser);
  const userId = user?.id;

  // ✅ Load persisted state
  const loadPersistedState = () => {
    const saved = localStorage.getItem('propertyDetailsFormState');
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error('Error parsing saved state:', e);
        return location.state || {};
      }
    }
    return location.state || {};
  };

  const persistedState = loadPersistedState();

  // State declarations
  const [profileData, setProfileData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [propertyImages, setPropertyImages] = useState([]);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [propertyVideos, setPropertyVideos] = useState(persistedState.propertyVideos || []);
  const [buildingName, setBuildingName] = useState(persistedState.buildingName || '');
  const [areaName, setAreaName] = useState(persistedState.areaName || '');
  const [completeAddress, setCompleteAddress] = useState(persistedState.completeAddress || '');
  const [locality, setLocality] = useState(persistedState.locality || '');
  const [landmark, setLandmark] = useState(persistedState.landmark || '');
  const [propertyDescription, setPropertyDescription] = useState(persistedState.propertyDescription || '');
  const [propertySize, setPropertySize] = useState(persistedState.propertySize || '');
  const [selectedUnit, setSelectedUnit] = useState(persistedState.selectedUnit || 'sq.yards');
  const [propertyLength, setPropertyLength] = useState(persistedState.propertyLength || '');
  const [lengthUnit, setLengthUnit] = useState(persistedState.lengthUnit || 'Sq.Ft');
  const [propertyWidth, setPropertyWidth] = useState(persistedState.propertyWidth || '');
  const [widthUnit, setWidthUnit] = useState(persistedState.widthUnit || 'Sq.Ft');
  const [totalFloors, setTotalFloors] = useState(persistedState.totalFloors || '');
  const [selectedFloor, setSelectedFloor] = useState(persistedState.selectedFloor || '');
  const [ownerName, setOwnerName] = useState(persistedState.ownerName || '');
  const [contactNumber, setContactNumber] = useState(persistedState.contactNumber || '');
  const [emailAddress, setEmailAddress] = useState(persistedState.emailAddress || '');
  const [socialMediaLink, setSocialMediaLink] = useState(persistedState.socialMediaLink || '');
  const [carpetArea, setCarpetArea] = useState(persistedState.carpetArea || '');
  const [carpetAreaUnits, setCarpetAreaUnits] = useState(persistedState.carpetAreaUnits || 'Sq.Ft');
  const [builtUpArea, setBuiltUpArea] = useState(persistedState.builtUpArea || '');
  const [builtUpAreaUnits, setBuiltUpAreaUnits] = useState(persistedState.builtUpAreaUnits || 'Sq.Ft');
  const [uds, setUds] = useState(persistedState.uds || '');
  const [udsUnits, setUdsUnits] = useState(persistedState.udsUnits || 'Sq.Yards');
  const [zoneType, setZoneType] = useState(persistedState.zoneType || '');
  const [selectedBHK, setSelectedBHK] = useState(persistedState.selectedBHK || "");
  const [selectedFurnish, setSelectedFurnish] = useState(persistedState.selectedFurnish || "");
  const [selectedHub, setSelectedHub] = useState(persistedState.selectedHub || '');
  const [selectedStatus, setSelectedStatus] = useState(persistedState.selectedStatus || '');
  const [selectedOwnership, setSelectedOwnership] = useState(persistedState.selectedOwnership || '');
  const [floorsAvailable, setFloorsAvailable] = useState(persistedState.floorsAvailable || "");
  const [areaSuggestions, setAreaSuggestions] = useState([]);
  const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);
  const [areaAnchorEl, setAreaAnchorEl] = useState(null);
  const [selectedAreaDetails, setSelectedAreaDetails] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const isCommercial = propertyType === 'Commercial';

  // Property types
  const [residentialPropertyTypes, setResidentialPropertyTypes] = useState([
    { id: "apartment", name: "Apartment", icon: apartmentIcon, selected: persistedState.selectedType === "apartment" || (!persistedState.selectedType && true) },
    { id: "independent-house", name: "Independent House", icon: independentHouseIcon, selected: persistedState.selectedType === "independent-house" },
    { id: "pent-house", name: "Pent House", icon: pentHouseIcon, selected: persistedState.selectedType === "pent-house" },
    { id: "studio", name: "Studio", icon: studioIcon, selected: persistedState.selectedType === "studio" },
    { id: "villa", name: "Villa", icon: villaIcon, selected: persistedState.selectedType === "villa" },
    { id: "plot", name: "Plot", icon: plotIcon, selected: persistedState.selectedType === "plot" },
    { id: "agriculture-land", name: "Agriculture Land", icon: agricultureLandIcon, selected: persistedState.selectedType === "agriculture-land" },
    { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: persistedState.selectedType === "farm-house" },
  ]);

  const [commercialPropertyTypes, setCommercialPropertyTypes] = useState([
    { id: "office", name: "Office", icon: OfficeIcon, selected: persistedState.selectedType === "office" || (!persistedState.selectedType && true) },
    { id: "showroom", name: "Showroom", icon: ShowroomIcon, selected: persistedState.selectedType === "showroom" },
    { id: "retail-shop", name: "Retail Shop", icon: RetailShopIcon, selected: persistedState.selectedType === "retail-shop" },
    { id: "warehouse", name: "Warehouse", icon: WarehouseIcon, selected: persistedState.selectedType === "warehouse" },
    { id: "plot", name: "Plot", icon: CommercialPlotIcon, selected: persistedState.selectedType === "plot" },
    { id: "farm-house", name: "Farm House", icon: farmHouseIcon, selected: persistedState.selectedType === "farm-house" }, // ✅ ADDED BACK
  ]);

  const [selectedPropertyType, setSelectedPropertyType] = useState(() => {
    if (persistedState.selectedType) {
      return persistedState.selectedType;
    }
    if (isCommercial) {
      return commercialPropertyTypes.find(t => t.selected)?.id || "office";
    }
    return residentialPropertyTypes.find(t => t.selected)?.id || "apartment";
  });

  // Image handling
  useEffect(() => {
    const isFreshEntry = location.state?.freshEntry === true;
    const isFromBackNavigation = location.state?.fromBackNavigation === true;
    const preserveImages = location.state?.preserveImages !== false;

    if (isFreshEntry && !isFromBackNavigation && !preserveImages) {
      console.log('🆕 Fresh entry - clearing images');
      setImagePreviews([]);
      setPropertyImages([]);
      localStorage.removeItem('propertyImagePreviews');
      setImagesLoaded(true);
    } else {
      const loadImagesFromStorage = async () => {
        const savedPreviews = localStorage.getItem('propertyImagePreviews');
        if (savedPreviews) {
          try {
            const previews = JSON.parse(savedPreviews);
            if (previews && previews.length > 0) {
              console.log(`📸 Loading ${previews.length} images from localStorage`);
              setImagePreviews(previews);
              
              const filePromises = previews.map((preview, index) =>
                base64ToFile(preview, `property-image-${index + 1}.jpg`)
              );
              
              const files = await Promise.all(filePromises);
              const validFiles = files.filter(file => file !== null);
              
              if (validFiles.length > 0) {
                setPropertyImages(validFiles);
              }
            }
          } catch (e) {
            console.error('Error loading images from localStorage:', e);
          }
        }
        setImagesLoaded(true);
      };

      if (!imagesLoaded) {
        loadImagesFromStorage();
      }
    }
  }, [location.state?.freshEntry, location.state?.fromBackNavigation, location.state?.preserveImages, imagesLoaded]);

  // Save state to localStorage
  useEffect(() => {
    const stateToSave = {
      propertyType,
      category,
      location: propLocation,
      selectedType: selectedPropertyType,
      buildingName,
      areaName,
      completeAddress,
      locality,
      landmark,
      propertyDescription,
      propertySize,
      selectedUnit,
      propertyLength,
      lengthUnit,
      propertyWidth,
      widthUnit,
      totalFloors,
      selectedFloor,
      ownerName,
      contactNumber,
      emailAddress,
      socialMediaLink,
      carpetArea,
      carpetAreaUnits,
      builtUpArea,
      builtUpAreaUnits,
      uds,
      udsUnits,
      zoneType,
      selectedBHK,
      selectedFurnish,
      selectedHub,
      selectedStatus,
      selectedOwnership,
      floorsAvailable,
      imageCount: propertyImages.length,
      videoCount: propertyVideos.length,
    };
    localStorage.setItem('propertyDetailsFormState', JSON.stringify(stateToSave));
  }, [
    propertyType, category, propLocation, selectedPropertyType, buildingName, areaName, completeAddress, 
    locality, landmark, propertyDescription, propertySize, selectedUnit, propertyLength, lengthUnit, 
    propertyWidth, widthUnit, totalFloors, selectedFloor, ownerName, contactNumber, emailAddress, 
    socialMediaLink, carpetArea, carpetAreaUnits, builtUpArea, builtUpAreaUnits, uds, udsUnits, zoneType,
    selectedBHK, selectedFurnish, selectedHub, selectedStatus, selectedOwnership, floorsAvailable, 
    propertyImages.length, propertyVideos.length
  ]);

  const bhkOptions = [
    { id: "1bhk", label: "1 BHK" },
    { id: "2bhk", label: "2 BHK" },
    { id: "3bhk", label: "3 BHK" },
    { id: "4bhk", label: "4 BHK" },
    { id: "5bhk", label: "5 BHK" },
    { id: "6bhk", label: "6 BHK" },
    { id: "6+bhk", label: "6+ BHK" },
  ];

  const furnishTypes = [
    { id: "fully-furnished", label: "Fully Furnished" },
    { id: "semi-furnished", label: "Semi Furnished" },
    { id: "un-furnished", label: "Un Furnished" },
  ];

  const hubs = ['IT Park', 'Business Park', 'Others'];
  const statuses = ['Ready to Occupy', 'Under Construction', 'Bare shell'];
  const ownerships = ['Freehold', 'Leasehold', 'Cooperative society', 'Power of attorney'];

  const getSelectedPropertyType = () => {
    if (isCommercial) {
      return commercialPropertyTypes.find(type => type.selected) || commercialPropertyTypes[0];
    }
    return residentialPropertyTypes.find(type => type.selected) || residentialPropertyTypes[0];
  };

  const calculateProgress = () => {
    const selectedType = getSelectedPropertyType();
    const isPlot = selectedType?.id === 'plot';
    const isAgricultureLand = selectedType?.id === 'agriculture-land';
    const isFarmhouse = selectedType?.id === 'farm-house';
    const isVilla = selectedType?.id === 'villa';
    let totalFields = 0;
    let filledFields = 0;

    if (buildingName) filledFields++;
    totalFields++;
    if (areaName) filledFields++;
    totalFields++;
    if (completeAddress) filledFields++;
    totalFields++;
    if (propertyImages.length > 0 || imagePreviews.length > 0) filledFields++;
    totalFields++;

    if (isPlot || isAgricultureLand) {
      if (propertySize) filledFields++;
      totalFields++;
      if (propertyLength) filledFields++;
      totalFields++;
      if (propertyWidth) filledFields++;
      totalFields++;
    } else if (isFarmhouse) {
      if (selectedBHK) filledFields++;
      totalFields++;
      if (selectedFurnish) filledFields++;
      totalFields++;
      if (builtUpArea) filledFields++;
      totalFields++;
    } else if (isVilla) {
      if (builtUpArea) filledFields++;
      totalFields++;
    } else {
      if (!isCommercial) {
        if (ownerName && ownerName !== 'N/A') filledFields++;
        totalFields++;
        if (contactNumber && contactNumber !== 'N/A') filledFields++;
        totalFields++;
        if (emailAddress && emailAddress !== 'N/A') filledFields++;
        totalFields++;
        if (selectedBHK) filledFields++;
        totalFields++;
        if (selectedFurnish) filledFields++;
        totalFields++;
      }
    }
    return Math.round((filledFields / totalFields) * 100);
  };

  const progress = calculateProgress();

  // Validation functions
  const validateAlphanumeric = (text, fieldName) => {
    if (!text || !text.trim()) return `${fieldName} is required`;
    if (text.trim().length < 3) return `${fieldName} must be at least 3 characters`;
    return "";
  };

  const validateName = (name) => {
    if (!name || !name.trim()) return "Name is required";
    if (name.trim().length < 3) return "Name must be at least 3 characters";
    return "";
  };

  const validateNumber = (value, fieldName, min = 1, max = null) => {
    if (!value || value === "") return `${fieldName} is required`;
    const numValue = Number(value);
    if (isNaN(numValue)) return `${fieldName} must be a number`;
    if (numValue < min) return `${fieldName} must be at least ${min}`;
    if (max !== null && numValue > max) return `${fieldName} must be less than ${max}`;
    return "";
  };

  const validateEmail = (email) => {
    if (!email || !email.trim()) return "Email is required";
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) return "Please enter a valid email address";
    return "";
  };

  const validatePhone = (phone) => {
    if (!phone || !phone.trim()) return "Phone number is required";
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) return "Phone must be exactly 10 digits";
    return "";
  };

  const validateCompleteAddress = (value) => {
    if (!value || !value.trim()) return "Complete address is required";
    if (value.trim().length < 10) return "Complete address must be at least 10 characters";
    return "";
  };


  // ✅ NEW: Validates alphanumeric input with max 5 characters
// ✅ NEW: Validates text (unlimited) + numbers (max 5 digits)
const validateAlphanumericField = (value, fieldName, isRequired = true) => {
  if (isRequired && (!value || !value.trim())) return `${fieldName} is required`;
  
  // Extract only numbers from the value
  const numbers = value.replace(/\D/g, '');
  
  // Check if numbers exceed 5 digits
  if (numbers.length > 5) return `${fieldName} can contain maximum 5 digits`;
  
  return "";
};
  const validateSocialMediaLink = (link) => {
    if (!link || !link.trim()) return "";
    
    const allowedDomains = [
      'youtube.com', 'youtu.be', 'www.youtube.com',
      'facebook.com', 'fb.com', 'www.facebook.com',
      'whatsapp.com', 'wa.me', 'www.whatsapp.com',
      'instagram.com', 'www.instagram.com'
    ];
    
    try {
      const url = new URL(link.startsWith('http') ? link : `https://${link}`);
      const hostname = url.hostname.toLowerCase().replace('www.', '');
      
      const isAllowed = allowedDomains.some(domain => 
        hostname === domain || hostname.endsWith(`.${domain}`)
      );
      
      if (!isAllowed) {
        return "Only YouTube, Facebook, WhatsApp, and Instagram links are allowed";
      }
      return "";
    } catch (e) {
      return "Please enter a valid URL";
    }
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!userId) {
        setLoadingProfile(false);
        return;
      }
      try {
        setLoadingProfile(true);
        const response = await fetch(`https://propertydealstalk.com/api/users/getUserProfile?user_id=${userId}`);
        const data = await response.json();
        if (data.status === "SUCCESS") {
          setProfileData(data.result);
          if (data.result.full_name) {
            setOwnerName(data.result.full_name);
          } else {
            setOwnerName('N/A');
          }
          if (data.result.contact_number) {
            setContactNumber(data.result.contact_number);
          } else {
            setContactNumber('N/A');
          }
          if (data.result.email_id) {
            setEmailAddress(data.result.email_id);
          } else {
            setEmailAddress('N/A');
          }
        }
      } catch (err) {
        console.error('Error fetching profile:', err);
      } finally {
        setLoadingProfile(false);
      }
    };
    fetchUserProfile();
  }, [userId]);

  const handleAreaNameChange = (e) => {
    const value = e.target.value;
    setAreaName(value);
    setAreaAnchorEl(e.currentTarget);
    if (!value) {
      setErrors(prev => ({...prev, areaName: 'Area Name is required'}));
    } else if (value.trim().length < 1) {
      setErrors(prev => ({...prev, areaName: 'Area Name must be at least 3 characters'}));
    } else {
      setErrors(prev => ({...prev, areaName: ''}));
    }
  };

  const handleSelectArea = (area) => {
    setAreaName(area.area);
    setSelectedAreaDetails({
      name: area.area,
      address: area.address,
      location: area.location
    });
    setAreaAnchorEl(null);
    setShowAreaSuggestions(false);
    setErrors(prev => ({...prev, areaName: ''}));
  };

  const handleAreaClickAway = () => {
    setShowAreaSuggestions(false);
  };

  const fetchAreaSuggestions = async (query, city) => {
    if (query.length < 1 || !city) return;
    try {
      const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(city)}&q=${encodeURIComponent(query)}`);
      const data = await response.json();
      if (data.success && data.areas && data.areas.length > 0) {
        const transformedAreas = data.areas.map(area => ({
          area: area.name,
          address: area.address,
          location: area.location
        }));
        setAreaSuggestions(transformedAreas);
        setShowAreaSuggestions(true);
      } else {
        setAreaSuggestions([]);
        setShowAreaSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching area suggestions:', error);
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  };

  useEffect(() => {
    if (areaName.trim().length > 0 && location.state?.location) {
      fetchAreaSuggestions(areaName, location.state.location);
    } else {
      setAreaSuggestions([]);
      setShowAreaSuggestions(false);
    }
  }, [areaName, location.state?.location]);

  const handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (files.length > 10) {
      alert("You can only upload up to 10 images");
      return;
    }

    const validFiles = Array.from(files).filter(file => file.type.startsWith('image/'));
    if (validFiles.length !== files.length) {
      alert("Only image files are allowed (JPEG, PNG, GIF, etc.)");
      return;
    }

    const newPreviews = [];
    const fileProcessPromises = validFiles.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          newPreviews.push(e.target.result);
          resolve();
        };
        reader.onerror = () => {
          console.error(`Failed to read file: ${file.name}`);
          resolve();
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(fileProcessPromises).then(() => {
      const updatedPreviews = [...imagePreviews, ...newPreviews];
      const updatedFiles = [...propertyImages, ...validFiles];
      setImagePreviews(updatedPreviews);
      setPropertyImages(updatedFiles);
      localStorage.setItem('propertyImagePreviews', JSON.stringify(updatedPreviews));
    });
  };

  const handlePropertyTypeSelect = (typeId) => {
    const previousType = selectedPropertyType;
    setSelectedPropertyType(typeId);

    if (previousType !== typeId) {
      const isPlot = typeId === 'plot';
      const isAgricultureLand = typeId === 'agriculture-land';
      const isFarmhouse = typeId === 'farm-house';
      const isVilla = typeId === 'villa';
      const wasPlot = previousType === 'plot';
      const wasAgricultureLand = previousType === 'agriculture-land';
      const wasFarmhouse = previousType === 'farm-house';
      const wasVilla = previousType === 'villa';

      if ((isPlot || isAgricultureLand) && (!wasPlot && !wasAgricultureLand && !wasFarmhouse && !wasVilla)) {
        setSelectedBHK('');
        setSelectedFurnish('');
        setCarpetArea('');
        setBuiltUpArea('');
        setUds('');
        setOwnerName('');
        setContactNumber('');
        setEmailAddress('');
        setSocialMediaLink('');
        setTotalFloors('');
        setSelectedFloor('');
      }
      else if ((!isPlot && !isAgricultureLand && !isFarmhouse && !isVilla) && (wasPlot || wasAgricultureLand)) {
        setPropertyDescription('');
        setPropertyLength('');
        setPropertyWidth('');
        setLandmark('');
        setZoneType('');
      }
      setErrors({});
    }

    if (isCommercial) {
      const updatedTypes = commercialPropertyTypes.map(type => ({
        ...type,
        selected: type.id === typeId
      }));
      setCommercialPropertyTypes(updatedTypes);
    } else {
      const updatedTypes = residentialPropertyTypes.map(type => ({
        ...type,
        selected: type.id === typeId
      }));
      setResidentialPropertyTypes(updatedTypes);
    }
  };

  const handleBack = () => {
    navigate('/add-new-property', { 
      state: { 
        propertyType: propertyType, 
        category: category, 
        location: location.state?.location || propLocation || localStorage.getItem('propertyLocation') || '', 
        asset_type: getSelectedPropertyType()?.name || '', 
        selectedType: getSelectedPropertyType()?.id || '', 
        fromPropertyDetails: true,
        preserveImages: true,
        fromBackNavigation: true,
        freshEntry: false,
      } 
    });
  };

  const handleNext = () => {
  let selectedType = null;
  if (isCommercial) {
    selectedType = commercialPropertyTypes.find(type => type.selected);
  } else {
    selectedType = residentialPropertyTypes.find(type => type.selected);
  }

  const isPlot = selectedType?.id === 'plot';
  const isAgricultureLand = selectedType?.id === 'agriculture-land';
  const isFarmhouse = selectedType?.id === 'farm-house';
  const isVilla = selectedType?.id === 'villa';
  const isApartment = selectedType?.id === 'apartment';
  const isIndependentHouse = selectedType?.id === 'independent-house';
  const isPentHouse = selectedType?.id === 'pent-house';
  const isStudio = selectedType?.id === 'studio';
  const isOffice = selectedType?.id === 'office';
  const isShowroom = selectedType?.id === 'showroom';
  const isRetailShop = selectedType?.id === 'retail-shop';
  const isWarehouse = selectedType?.id === 'warehouse';

  let validationErrors = {
    buildingName: validateAlphanumeric(buildingName, "Building name"),
    areaName: validateName(areaName),
     completeAddress: validateAlphanumericField(completeAddress, "Complete address", true), // ✅ Changed

    propertyDescription: validateAlphanumericField(propertyDescription, "Property description"),
  };

  // ========== APARTMENT VALIDATION ==========
  if (isApartment) {
    validationErrors.carpetArea = validateNumber(carpetArea, "Carpet area");
    validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
    
    if (!isCommercial) {
      validationErrors = {
        ...validationErrors,
        ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
        contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
        emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
        bhk: selectedBHK ? '' : 'Please select BHK',
        furnish: selectedFurnish ? '' : 'Please select furnish type',
      };
    }
  }
  // ========== INDEPENDENT HOUSE VALIDATION ==========
  else if (isIndependentHouse) {
    validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
    
    if (!isCommercial) {
      validationErrors = {
        ...validationErrors,
        ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
        contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
        emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
        bhk: selectedBHK ? '' : 'Please select BHK',
        furnish: selectedFurnish ? '' : 'Please select furnish type',
      };
    }
  }
  // ========== PENT HOUSE VALIDATION (ONLY built_up_area mandatory) ==========
  else if (isPentHouse) {
    validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
    
    if (!isCommercial) {
      validationErrors = {
        ...validationErrors,
        ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
        contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
        emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
        bhk: selectedBHK ? '' : 'Please select BHK',
        furnish: selectedFurnish ? '' : 'Please select furnish type',
      };
    }
  }
  // ========== STUDIO VALIDATION ==========
  else if (isStudio) {
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
    
    if (!isCommercial) {
      validationErrors = {
        ...validationErrors,
        ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
        contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
        emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
        bhk: selectedBHK ? '' : 'Please select BHK',
        furnish: selectedFurnish ? '' : 'Please select furnish type',
      };
    }
  }
  // ========== VILLA VALIDATION ==========
  else if (isVilla) {
    validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
    
    if (!isCommercial) {
      validationErrors = {
        ...validationErrors,
        ownerName: (ownerName === 'N/A' || !ownerName) ? 'Owner name is required' : validateName(ownerName),
        contactNumber: (contactNumber === 'N/A' || !contactNumber) ? 'Contact number is required' : validatePhone(contactNumber),
        emailAddress: (emailAddress === 'N/A' || !emailAddress) ? 'Email address is required' : validateEmail(emailAddress),
        bhk: selectedBHK ? '' : 'Please select BHK',
        furnish: selectedFurnish ? '' : 'Please select furnish type',
      };
    }
  }
  // ========== PLOT & AGRICULTURE LAND VALIDATION ==========
  else if (isPlot || isAgricultureLand) {
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
    
  }
  // ========== FARMHOUSE VALIDATION ==========
  else if (isFarmhouse) {
    validationErrors.builtUpArea = validateNumber(builtUpArea, "Built-up area");
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
    validationErrors.bhk = selectedBHK ? '' : 'Please select BHK';
    validationErrors.furnish = selectedFurnish ? '' : 'Please select furnish type';
  }
  // ========== COMMERCIAL OFFICE VALIDATION ==========
  else if (isCommercial && isOffice) {
    validationErrors.totalFloors = validateNumber(totalFloors, "Total floors", 1, 100);
    validationErrors.selectedFloor = selectedFloor ? '' : 'Please select floor';
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
  }
  // ========== COMMERCIAL SHOWROOM & RETAIL SHOP VALIDATION ==========
  else if (isCommercial && (isShowroom || isRetailShop)) {
    validationErrors.totalFloors = validateNumber(totalFloors, "Total floors", 1, 100);
    validationErrors.selectedFloor = selectedFloor ? '' : 'Please select floor';
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
  }
  // ========== COMMERCIAL WAREHOUSE VALIDATION ==========
  else if (isCommercial && isWarehouse) {
    validationErrors.totalFloors = validateNumber(totalFloors, "Total floors", 1, 100);
    validationErrors.selectedFloor = selectedFloor ? '' : 'Please select floor';
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
  }
  // ========== COMMERCIAL PLOT VALIDATION ==========
  else if (isCommercial && isPlot) {
    validationErrors.propertySize = validateNumber(propertySize, "Property size");
  }

  // Social media link validation
  if (socialMediaLink && socialMediaLink.trim()) {
    validationErrors.socialMediaLink = validateSocialMediaLink(socialMediaLink);
  }

  setErrors(validationErrors);
  const hasErrors = Object.values(validationErrors).some(error => error);

  if (hasErrors) {
    const firstErrorField = Object.keys(validationErrors).find(key => validationErrors[key]);
    if (firstErrorField) {
      const element = document.getElementById(firstErrorField);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }
    return;
  }

  // ✅ Build propertyDetails object with ALL values preserved
  const propertyDetails = {
    // Basic info
    propertyType: isCommercial ? 'Commercial' : 'Residential',
    category: category,
    location: location.state?.location || propLocation || '',
    asset_type: selectedType?.name || '',
    selectedType: selectedType?.id || '',
    
    // Property names and addresses
    property_name: buildingName,
    buildingName: buildingName,
    area_name: areaName,
    areaName: areaName,
    full_address: completeAddress,
    completeAddress: completeAddress,
    locality: locality || '',
    landmark: landmark || '',
    description: propertyDescription || '',
    propertyDescription: propertyDescription || '',
    
    // Social media / YouTube link
    youtube_link: socialMediaLink?.trim() || '',
    social_media_link: socialMediaLink?.trim() || '',
    socialMediaLink: socialMediaLink?.trim() || '',
    
    // BHK and Furnishing (for applicable types)
    bhk: selectedBHK || '',
    selectedBHK: selectedBHK || '',
    furnish_type: selectedFurnish || '',
    selectedFurnish: selectedFurnish || '',
    
    // ✅ AREA FIELDS - Always send actual values or empty string
    carpet_area: carpetArea || '',
    carpet_area_units: carpetArea ? (carpetAreaUnits || 'Sq.Ft') : '',
    carpetAreaUnits: carpetArea ? (carpetAreaUnits || 'Sq.Ft') : '',
    
    built_up_area: builtUpArea || '',
    built_up_area_units: builtUpArea ? (builtUpAreaUnits || 'Sq.Ft') : '',
    builtUpArea: builtUpArea || '',
    builtUpAreaUnits: builtUpArea ? (builtUpAreaUnits || 'Sq.Ft') : '',
    
    uds: uds || '',
    uds_units: uds ? (udsUnits || 'Sq.Yards') : '',
    udsUnits: uds ? (udsUnits || 'Sq.Yards') : '',
    
    // Property size
    property_size: propertySize || '',
    propertySize: propertySize || '',
    property_size_units: propertySize ? (selectedUnit || 'Sq.Ft') : '',
    selectedUnit: propertySize ? (selectedUnit || 'Sq.Ft') : '',
    
    // Zone type
    zone_type: zoneType || '',
    zoneType: zoneType || '',
    
    ownership: (isPlot || isAgricultureLand) ? (selectedOwnership || '') : '',
    selectedOwnership: (isPlot || isAgricultureLand) ? (selectedOwnership || '') : '',
    // Length and Width
    length: propertyLength || '',
    propertyLength: propertyLength || '',
    length_units: propertyLength ? (lengthUnit || 'Sq.Ft') : '',
    lengthUnit: propertyLength ? (lengthUnit || 'Sq.Ft') : '',
    
    width: propertyWidth || '',
    propertyWidth: propertyWidth || '',
    width_units: propertyWidth ? (widthUnit || 'Sq.Ft') : '',
    widthUnit: propertyWidth ? (widthUnit || 'Sq.Ft') : '',
    
    // Floors
    total_floors: totalFloors || '',
    totalFloors: totalFloors || '',
    select_floor: selectedFloor || '',
    selectedFloor: selectedFloor || '',
    
    // Contact info (for non-commercial residential)
    ownerName: ownerName || '',
    contactNumber: contactNumber || '',
    emailAddress: emailAddress || '',
    
    // Media
    propertyImages: propertyImages || [],
    propertyVideos: propertyVideos || [],
    
    // Navigation flags
    freshEntry: false,
    fromPropertyDetails: true,
    preserveImages: true,
  };

  // ✅ Add commercial-specific fields
  if (isCommercial) {
    propertyDetails.commercial_catgory = category.toLowerCase() === 'sell' ? 'sale' : 'rent';
    propertyDetails.commercial_asset_type = selectedType?.name || '';
    propertyDetails.hub = selectedHub || '';
    propertyDetails.selectedHub = selectedHub || '';
    // propertyDetails.ownership = selectedOwnership || '';
   
    propertyDetails.floors_available = floorsAvailable || '';
    propertyDetails.floorsAvailable = floorsAvailable || '';
  }

 // ✅ FIXED: Correct amenities logic for commercial farmhouse
const shouldShowAmenities = (isFarmhouse || isVilla || (!isCommercial && !isPlot && !isAgricultureLand));

console.log('🔍 Navigation Debug:', {
  isCommercial,
  isFarmhouse,
  isPlot,
  isAgricultureLand,
  shouldShowAmenities,
  selectedTypeId: selectedType?.id,
  selectedTypeName: selectedType?.name
});

if (shouldShowAmenities) {
  navigate('/amenities', { state: propertyDetails });
} else {
  localStorage.removeItem('amenities_society');
  localStorage.removeItem('amenities_furnishing');
  localStorage.removeItem('amenities_other');

  if (category === 'Rent') {
    navigate('/rent-details', { state: propertyDetails });
  } else if (category === 'Sell') {
    navigate('/price-details', { state: propertyDetails });
  }
}
};

  useEffect(() => {
    if (isCommercial) {
      if (!selectedHub) setSelectedHub('Business Park');
      if (!selectedStatus) setSelectedStatus('Ready to Occupy');
      if (!selectedOwnership) setSelectedOwnership('Freehold');
    }
  }, [isCommercial]);

  const renderForm = () => {
    const selectedType = getSelectedPropertyType();
    const isPlot = selectedType?.id === 'plot';
    const isAgricultureLand = selectedType?.id === 'agriculture-land';
    const isFarmhouse = selectedType?.id === 'farm-house';
    const isVilla = selectedType?.id === 'villa';
    const isApartment = selectedType?.id === 'apartment';
    const isIndependentHouse = selectedType?.id === 'independent-house';
    const isPentHouse = selectedType?.id === 'pent-house';
    const isStudio = selectedType?.id === 'studio';
    const isOffice = selectedType?.id === 'office';
    const isShowroom = selectedType?.id === 'showroom';
    const isRetailShop = selectedType?.id === 'retail-shop';
    const isWarehouse = selectedType?.id === 'warehouse';

    return (
      <Box>
        {/* Property Type & Upload Images */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Property Type <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <FormControl fullWidth size="small">
                <Select
                  value={selectedPropertyType}
                  onChange={(e) => handlePropertyTypeSelect(e.target.value)}
                  displayEmpty
                  sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                  renderValue={(selected) => {
                    const propertyTypes = isCommercial ? commercialPropertyTypes : residentialPropertyTypes;
                    const selectedTypeObj = propertyTypes.find(type => type.id === selected);
                    if (!selectedTypeObj) {
                      return <em style={{ color: '#999' }}>Select Property Type</em>;
                    }
                    return (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box component="img" src={selectedTypeObj.icon} alt={selectedTypeObj.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                        <Typography sx={{ fontFamily: 'Outfit', fontSize: '13px' }}>
                          {selectedTypeObj.name}
                        </Typography>
                      </Box>
                    );
                  }}
                >
                  {(isCommercial ? commercialPropertyTypes : residentialPropertyTypes).map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box component="img" src={type.icon} alt={type.name} sx={{ width: 20, height: 20, objectFit: 'contain' }} />
                        {type.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Upload Images
              </Typography>
              <Box
                sx={{
                  height: 36,
                  border: '2px dashed #d0d0d0',
                  borderRadius: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': { backgroundColor: '#f9f9f9', borderColor: '#1976d2' },
                }}
                onClick={() => document.getElementById('property-images').click()}
              >
                <input
                  type="file"
                  id="property-images"
                  multiple
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageUpload}
                />
                <CloudUpload sx={{ width: 24, height: 24, mr: 1, color: '#1976d2' }} />
                <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#666', fontFamily: 'Outfit' }}>
                  Upload (Max 10)
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Display uploaded images */}
        {imagePreviews && imagePreviews.length > 0 && (
          <Box sx={{ mb: 3 }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 1 }}>
              {imagePreviews.length} {imagePreviews.length === 1 ? 'image' : 'images'} uploaded
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, p: 2, border: '1px solid #e0e0e0', borderRadius: 1.5, backgroundColor: '#fafafa' }}>
              {imagePreviews.map((preview, index) => (
                <Box
                  key={`img-preview-${index}`}
                  sx={{
                    position: 'relative',
                    width: '100px',
                    height: '100px',
                    borderRadius: 1.5,
                    overflow: 'hidden',
                    border: '2px solid #e0e0e0',
                    cursor: 'pointer',
                    flexShrink: 0,
                    '&:hover': { borderColor: '#1976d2' }
                  }}
                  onClick={() => {
                    setSelectedImageIndex(index);
                    setPreviewOpen(true);
                  }}
                >
                  <Box
                    component="img"
                    src={preview}
                    alt={`Preview ${index + 1}`}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                  <IconButton
                    size="small"
                    sx={{
                      position: 'absolute',
                      top: -8,
                      right: -8,
                      bgcolor: '#ff4444',
                      color: 'white',
                      width: 24,
                      height: 24,
                      fontSize: '14px',
                      '&:hover': { bgcolor: '#cc0000' }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const newPreviews = [...imagePreviews];
                      const newFiles = [...propertyImages];
                      newPreviews.splice(index, 1);
                      newFiles.splice(index, 1);
                      setImagePreviews(newPreviews);
                      setPropertyImages(newFiles);
                      if (newPreviews.length > 0) {
                        localStorage.setItem('propertyImagePreviews', JSON.stringify(newPreviews));
                      } else {
                        localStorage.removeItem('propertyImagePreviews');
                      }
                    }}
                  >
                    ×
                  </IconButton>
                </Box>
              ))}
            </Box>
          </Box>
        )}

        {/* Building Name & Area Name */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Building/Project Name <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <TextField
                id="buildingName"
                fullWidth
                size="small"
                placeholder="Enter building name"
                value={buildingName}
                onChange={(e) => {
                  setBuildingName(e.target.value);
                  setErrors(prev => ({...prev, buildingName: validateAlphanumeric(e.target.value, "Building name")}));
                }}
                error={!!errors.buildingName}
                helperText={errors.buildingName}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Box sx={{ width: '410px', maxWidth: '100%' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                Area Name <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <ClickAwayListener onClickAway={handleAreaClickAway}>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    id="areaName"
                    fullWidth
                    size="small"
                    placeholder="Enter area name"
                    value={areaName}
                    onChange={handleAreaNameChange}
                    error={!!errors.areaName}
                    helperText={errors.areaName}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                  {showAreaSuggestions && areaSuggestions.length > 0 && (
                    <Popper
                      open={showAreaSuggestions}
                      anchorEl={areaAnchorEl}
                      placement="bottom-start"
                      transition
                      style={{ width: areaAnchorEl ? areaAnchorEl.clientWidth : 'auto', zIndex: 1300 }}
                    >
                      {({ TransitionProps }) => (
                        <Grow {...TransitionProps} timeout={200}>
                          <Paper elevation={3} sx={{ maxHeight: 200, overflow: 'auto', mt: 0.5, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                            <List dense>
                              {areaSuggestions.map((area, index) => (
                                <ListItem
                                  key={index}
                                  button
                                  onClick={() => handleSelectArea(area)}
                                  sx={{ py: 0.8, '&:hover': { backgroundColor: '#f5f5f5' } }}
                                >
                                  <ListItemText
                                    primary={area.area}
                                    primaryTypographyProps={{ fontFamily: 'Outfit', fontWeight: 500, fontSize: '13px' }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
                </Box>
              </ClickAwayListener>
            </Box>
          </Grid>
        </Grid>

        {/* ✅ Complete Address & Description (Side by Side) - FOR ALL TYPES */}
<Grid container spacing={2} sx={{ mb: 3 }}>
<Grid item xs={12} sm="auto">
  <Box sx={{ width: '400px', maxWidth: '100%' }}>
    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
      Complete Address <span style={{ color: '#d32f2f' }}>*</span>
    </Typography>
    <TextField
      id="completeAddress"
      fullWidth
      size="small"
      multiline
      rows={3}
      placeholder="Enter address (max 5 digits allowed)"
      value={completeAddress}
      onChange={(e) => {
        const value = e.target.value;
        
        // ✅ Extract numbers and check if they exceed 5 digits
        const numbers = value.replace(/\D/g, '');
        
        // ✅ Only update if numbers are 5 or less
        if (numbers.length <= 5) {
          setCompleteAddress(value);
          setErrors(prev => ({...prev, completeAddress: validateAlphanumericField(value, "Complete address", true)}));
        }
      }}
      error={!!errors.completeAddress}
      helperText={errors.completeAddress}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
    />
  </Box>
</Grid>

  <Grid item xs={12} sm="auto">
  <Box sx={{ width: '400px', maxWidth: '100%' }}>
    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
      Description <span style={{ color: '#999', fontSize: '11px' }}>(Optional - max 5 digits)</span>
    </Typography>
    <TextField
      id="propertyDescription"
      fullWidth
      size="small"
      multiline
      rows={3}
      placeholder="Enter description (max 5 digits allowed)"
      value={propertyDescription}
      onChange={(e) => {
        const value = e.target.value;
        
        // ✅ Extract numbers and check if they exceed 5 digits
        const numbers = value.replace(/\D/g, '');
        
        // ✅ Only update if numbers are 5 or less
        if (numbers.length <= 5) {
          setPropertyDescription(value);
          if (value) {
            setErrors(prev => ({...prev, propertyDescription: validateAlphanumericField(value, "Description", false)}));
          } else {
            setErrors(prev => ({...prev, propertyDescription: ''}));
          }
        }
      }}
      error={!!errors.propertyDescription}
      helperText={errors.propertyDescription}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
    />
  </Box>
</Grid>
</Grid>

        {/* ✅ APARTMENT FIELDS */}
        {isApartment && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            {!isCommercial && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                  Contact Information <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Owner Name
                      </Typography>
                      <TextField
                        id="ownerName"
                        fullWidth
                        size="small"
                        placeholder="Enter owner name"
                        value={ownerName}
                        onChange={(e) => {
                          setOwnerName(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                        error={!!errors.ownerName}
                        helperText={errors.ownerName}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Contact Number
                      </Typography>
                      <TextField
                        id="contactNumber"
                        fullWidth
                        size="small"
                        type="tel"
                        placeholder="Enter contact number"
                        value={contactNumber}
                                               onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'N/A' || value === '') {
                            setContactNumber(value);
                          } else {
                            const numericValue = value.replace(/\D/g, '').slice(0, 10);
                            setContactNumber(numericValue);
                            if (numericValue !== 'N/A') {
                              setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                            }
                          }
                        }}
                        disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                        error={!!errors.contactNumber}
                        helperText={errors.contactNumber}
                        inputProps={{ maxLength: 10 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <TextField
                        id="emailAddress"
                        fullWidth
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* ✅ Carpet Area, Built-up Area, UDS (optional) - Units inline */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Carpet Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="carpetArea"
                    fullWidth
                    size="small"
                    placeholder="Enter carpet area"
                    value={carpetArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setCarpetArea(value);
                      setErrors(prev => ({...prev, carpetArea: validateNumber(value, "Carpet area")}));
                    }}
                    error={!!errors.carpetArea}
                    helperText={errors.carpetArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                      setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                    }}
                    error={!!errors.builtUpArea}
                    helperText={errors.builtUpArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="uds"
                    fullWidth
                    size="small"
                    placeholder="Enter UDS"
                    value={uds}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setUds(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* ✅ INDEPENDENT HOUSE FIELDS */}
        {isIndependentHouse && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            {!isCommercial && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                  Contact Information <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Owner Name
                      </Typography>
                      <TextField
                        id="ownerName"
                        fullWidth
                        size="small"
                        placeholder="Enter owner name"
                        value={ownerName}
                        onChange={(e) => {
                          setOwnerName(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                        error={!!errors.ownerName}
                        helperText={errors.ownerName}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Contact Number
                      </Typography>
                      <TextField
                        id="contactNumber"
                        fullWidth
                        size="small"
                        type="tel"
                        placeholder="Enter contact number"
                        value={contactNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'N/A' || value === '') {
                            setContactNumber(value);
                          } else {
                            const numericValue = value.replace(/\D/g, '').slice(0, 10);
                            setContactNumber(numericValue);
                            if (numericValue !== 'N/A') {
                              setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                            }
                          }
                        }}
                        disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                        error={!!errors.contactNumber}
                        helperText={errors.contactNumber}
                        inputProps={{ maxLength: 10 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <TextField
                        id="emailAddress"
                        fullWidth
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* ✅ Built-up Area, Property Size, UDS (optional) - Units inline */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                      setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                    }}
                    error={!!errors.builtUpArea}
                    helperText={errors.builtUpArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    UDS <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="uds"
                    fullWidth
                    size="small"
                    placeholder="Enter UDS"
                    value={uds}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setUds(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Yards</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* ✅ PENT HOUSE FIELDS - Only Built-up Area (NO property size, NO carpet area) */}
        {isPentHouse && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            {!isCommercial && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                  Contact Information <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Owner Name
                      </Typography>
                      <TextField
                        id="ownerName"
                        fullWidth
                        size="small"
                        placeholder="Enter owner name"
                        value={ownerName}
                        onChange={(e) => {
                          setOwnerName(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                        error={!!errors.ownerName}
                        helperText={errors.ownerName}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Contact Number
                      </Typography>
                      <TextField
                        id="contactNumber"
                        fullWidth
                        size="small"
                        type="tel"
                        placeholder="Enter contact number"
                        value={contactNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'N/A' || value === '') {
                            setContactNumber(value);
                          } else {
                            const numericValue = value.replace(/\D/g, '').slice(0, 10);
                            setContactNumber(numericValue);
                            if (numericValue !== 'N/A') {
                              setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                            }
                          }
                        }}
                        disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                        error={!!errors.contactNumber}
                        helperText={errors.contactNumber}
                        inputProps={{ maxLength: 10 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <TextField
                        id="emailAddress"
                        fullWidth
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* ✅ Built-up Area ONLY (mandatory for Pent House) */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                      setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                    }}
                    error={!!errors.builtUpArea}
                    helperText={errors.builtUpArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* ✅ STUDIO FIELDS */}
        {isStudio && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            {!isCommercial && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                  Contact Information <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Owner Name
                      </Typography>
                      <TextField
                        id="ownerName"
                        fullWidth
                        size="small"
                        placeholder="Enter owner name"
                        value={ownerName}
                        onChange={(e) => {
                          setOwnerName(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                        error={!!errors.ownerName}
                        helperText={errors.ownerName}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Contact Number
                      </Typography>
                      <TextField
                        id="contactNumber"
                        fullWidth
                        size="small"
                        type="tel"
                        placeholder="Enter contact number"
                        value={contactNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'N/A' || value === '') {
                            setContactNumber(value);
                          } else {
                            const numericValue = value.replace(/\D/g, '').slice(0, 10);
                            setContactNumber(numericValue);
                            if (numericValue !== 'N/A') {
                              setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                            }
                          }
                        }}
                        disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                        error={!!errors.contactNumber}
                        helperText={errors.contactNumber}
                        inputProps={{ maxLength: 10 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <TextField
                        id="emailAddress"
                        fullWidth
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* ✅ Property Size for Studio */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* ✅ VILLA FIELDS */}
        {isVilla && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '210px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Contact Information */}
            {!isCommercial && (
              <Box sx={{ mb: 3 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                  Contact Information <span style={{ color: '#d32f2f' }}>*</span>
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Owner Name
                      </Typography>
                      <TextField
                        id="ownerName"
                        fullWidth
                        size="small"
                        placeholder="Enter owner name"
                        value={ownerName}
                        onChange={(e) => {
                          setOwnerName(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, ownerName: validateName(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A'}
                        error={!!errors.ownerName}
                        helperText={errors.ownerName}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.full_name && profileData.full_name !== '' && profileData.full_name !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Contact Number
                      </Typography>
                      <TextField
                        id="contactNumber"
                        fullWidth
                        size="small"
                        type="tel"
                        placeholder="Enter contact number"
                        value={contactNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === 'N/A' || value === '') {
                            setContactNumber(value);
                          } else {
                            const numericValue = value.replace(/\D/g, '').slice(0, 10);
                            setContactNumber(numericValue);
                            if (numericValue !== 'N/A') {
                              setErrors(prev => ({...prev, contactNumber: validatePhone(numericValue)}));
                            }
                          }
                        }}
                        disabled={profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A'}
                        error={!!errors.contactNumber}
                        helperText={errors.contactNumber}
                        inputProps={{ maxLength: 10 }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.contact_number && profileData.contact_number !== '' && profileData.contact_number !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm="auto">
                    <Box sx={{ width: '270px', maxWidth: '100%' }}>
                      <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#666', fontFamily: 'Outfit', mb: 0.5 }}>
                        Email Address
                      </Typography>
                      <TextField
                        id="emailAddress"
                        fullWidth
                        size="small"
                        type="email"
                        placeholder="Enter email address"
                        value={emailAddress}
                        onChange={(e) => {
                          setEmailAddress(e.target.value);
                          if (e.target.value !== 'N/A') {
                            setErrors(prev => ({...prev, emailAddress: validateEmail(e.target.value)}));
                          }
                        }}
                        disabled={profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A'}
                        error={!!errors.emailAddress}
                        helperText={errors.emailAddress}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 1.5,
                            fontFamily: 'Outfit',
                            fontSize: '13px',
                            backgroundColor: (profileData?.email_id && profileData.email_id !== '' && profileData.email_id !== 'N/A') ? '#f5f5f5' : 'white'
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}

            {/* ✅ Built-up Area and Property Size for Villa */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                      setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                    }}
                    error={!!errors.builtUpArea}
                    helperText={errors.builtUpArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

      {/* ✅ PLOT & AGRICULTURE LAND FIELDS (Residential only) */}
{!isCommercial && (isPlot || isAgricultureLand) && (
  <>
    {/* Social Media Link */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '410px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="socialMediaLink"
            fullWidth
            size="small"
            type="url"
            placeholder="YouTube, Facebook, WhatsApp, Instagram"
            value={socialMediaLink}
            onChange={(e) => {
              setSocialMediaLink(e.target.value);
              if (e.target.value) {
                setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
              } else {
                setErrors(prev => ({...prev, socialMediaLink: ''}));
              }
            }}
            error={!!errors.socialMediaLink}
            helperText={errors.socialMediaLink}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>
    </Grid>

    {/* Property Size, Zone Type, Ownership */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Property Size <span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              id="propertySize"
              fullWidth
              size="small"
              placeholder="Enter size"
              value={propertySize}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                setPropertySize(value);
                setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
              }}
              error={!!errors.propertySize}
              helperText={errors.propertySize}
              sx={{ 
                flex: 1,
                '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
              }}
            />
            <FormControl size="small" sx={{ minWidth: 100 }}>
              <Select
                value={selectedUnit}
                onChange={(e) => setSelectedUnit(e.target.value)}
                sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
              >
                <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                <MenuItem value="acres">Acres</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="zoneType"
            fullWidth
            size="small"
            placeholder="Enter zone type"
            value={zoneType}
            onChange={(e) => setZoneType(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              value={selectedOwnership}
              onChange={(e) => setSelectedOwnership(e.target.value)}
              displayEmpty
              sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
            >
              <MenuItem value=""><em>Select Ownership</em></MenuItem>
              {ownerships.map((own) => (
                <MenuItem key={own} value={own}>{own}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
    </Grid>

    {/* Length and Width removed for Agriculture Land */}
    {!isAgricultureLand && (
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '270px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
            </Typography>
            <TextField
              id="propertyLength"
              fullWidth
              size="small"
              placeholder="Enter length"
              value={propertyLength}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                setPropertyLength(value);
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
              }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>

        <Grid item xs={12} sm="auto">
          <Box sx={{ width: '270px', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
              Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
            </Typography>
            <TextField
              id="propertyWidth"
              fullWidth
              size="small"
              placeholder="Enter width"
              value={propertyWidth}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                setPropertyWidth(value);
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
              }}
              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
            />
          </Box>
        </Grid>
      </Grid>
    )}
  </>
)}

        {/* ✅ FARMHOUSE FIELDS */}
        {isFarmhouse && (
          <>
            {/* Social Media Link, BHK, Furnish Type */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '300px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '180px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    BHK <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.bhk}>
                    <Select
                      value={selectedBHK}
                      onChange={(e) => {
                        setSelectedBHK(e.target.value);
                        setErrors({...errors, bhk: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select BHK</em></MenuItem>
                      {bhkOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>{option.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.bhk && <FormHelperText sx={{ fontSize: '11px' }}>{errors.bhk}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '230px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Furnish Type <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <FormControl fullWidth size="small" error={!!errors.furnish}>
                    <Select
                      value={selectedFurnish}
                      onChange={(e) => {
                        setSelectedFurnish(e.target.value);
                        setErrors({...errors, furnish: ''});
                      }}
                      displayEmpty
                      sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                    >
                      <MenuItem value="" disabled><em>Select Furnish Type</em></MenuItem>
                      {furnishTypes.map((type) => (
                        <MenuItem key={type.id} value={type.id}>{type.label}</MenuItem>
                      ))}
                    </Select>
                    {errors.furnish && <FormHelperText sx={{ fontSize: '11px' }}>{errors.furnish}</FormHelperText>}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            {/* Built-up Area (MANDATORY) and Property Size */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                      setErrors(prev => ({...prev, builtUpArea: validateNumber(value, "Built-up area")}));
                    }}
                    error={!!errors.builtUpArea}
                    helperText={errors.builtUpArea}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>
          </>
        )}

        {/* ✅ COMMERCIAL OFFICE FIELDS */}
        {isCommercial && isOffice && (
          <>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Property Size */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '280px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Built-up Area and Zone Type (Optional) */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="zoneType"
                    fullWidth
                    size="small"
                    placeholder="Enter zone type"
                    value={zoneType}
                    onChange={(e) => setZoneType(e.target.value)}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Available Floors Section */}
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                Available Floors <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Total Floors
                    </Typography>
                    <TextField
                      id="totalFloors"
                      fullWidth
                      size="small"
                      placeholder="Enter total floors"
                      value={totalFloors}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setTotalFloors(value);
                        setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                      }}
                      error={!!errors.totalFloors}
                      helperText={errors.totalFloors}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Select Floor
                    </Typography>
                    <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                      <Select
                        id="selectedFloor"
                        value={selectedFloor}
                        onChange={(e) => {
                          setSelectedFloor(e.target.value);
                          setErrors({...errors, selectedFloor: ''});
                        }}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled>Select Floor</MenuItem>
                        {[...Array(20)].map((_, i) => (
                          <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                            {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Ownership
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedOwnership}
                        onChange={(e) => setSelectedOwnership(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                        {ownerships.map((own) => (
                          <MenuItem key={own} value={own}>{own}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Hub
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedHub}
                        onChange={(e) => setSelectedHub(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                        {hubs.map((hub) => (
                          <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        {/* ✅ COMMERCIAL SHOWROOM & RETAIL SHOP FIELDS */}
        {isCommercial && (isShowroom || isRetailShop) && (
          <>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Property Size */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Built-up Area and Carpet Area (Optional) */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="carpetArea"
                    fullWidth
                    size="small"
                    placeholder="Enter carpet area"
                    value={carpetArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setCarpetArea(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Available Floors Section */}
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                Available Floors <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Total Floors
                    </Typography>
                    <TextField
                      id="totalFloors"
                      fullWidth
                      size="small"
                      placeholder="Enter total floors"
                      value={totalFloors}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setTotalFloors(value);
                        setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                      }}
                      error={!!errors.totalFloors}
                      helperText={errors.totalFloors}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Select Floor
                    </Typography>
                    <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                      <Select
                        id="selectedFloor"
                        value={selectedFloor}
                        onChange={(e) => {
                          setSelectedFloor(e.target.value);
                          setErrors({...errors, selectedFloor: ''});
                        }}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled>Select Floor</MenuItem>
                        {[...Array(20)].map((_, i) => (
                          <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                            {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Ownership
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedOwnership}
                        onChange={(e) => setSelectedOwnership(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                        {ownerships.map((own) => (
                          <MenuItem key={own} value={own}>{own}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Hub
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedHub}
                        onChange={(e) => setSelectedHub(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                        {hubs.map((hub) => (
                          <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        {/* ✅ COMMERCIAL WAREHOUSE FIELDS */}
        {isCommercial && isWarehouse && (
          <>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="socialMediaLink"
                    fullWidth
                    size="small"
                    type="url"
                    placeholder="YouTube, Facebook, WhatsApp, Instagram"
                    value={socialMediaLink}
                    onChange={(e) => {
                      setSocialMediaLink(e.target.value);
                      if (e.target.value) {
                        setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
                      } else {
                        setErrors(prev => ({...prev, socialMediaLink: ''}));
                      }
                    }}
                    error={!!errors.socialMediaLink}
                    helperText={errors.socialMediaLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Property Size */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '410px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Property Size <span style={{ color: '#d32f2f' }}>*</span>
                  </Typography>
                  <TextField
                    id="propertySize"
                    fullWidth
                    size="small"
                    placeholder="Enter property size"
                    value={propertySize}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setPropertySize(value);
                      setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
                    }}
                    error={!!errors.propertySize}
                    helperText={errors.propertySize}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Zone Type, Built-up Area, Carpet Area (All Optional) */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="zoneType"
                    fullWidth
                    size="small"
                    placeholder="Enter zone type"
                    value={zoneType}
                    onChange={(e) => setZoneType(e.target.value)}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Built-up Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="builtUpArea"
                    fullWidth
                    size="small"
                    placeholder="Enter built-up area"
                    value={builtUpArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setBuiltUpArea(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box sx={{ width: '270px', maxWidth: '100%' }}>
                  <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                    Carpet Area <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
                  </Typography>
                  <TextField
                    id="carpetArea"
                    fullWidth
                    size="small"
                    placeholder="Enter carpet area"
                    value={carpetArea}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setCarpetArea(value);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
                    }}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Available Floors Section */}
            <Box sx={{ mb: 3 }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#333', fontFamily: 'Outfit', mb: 2 }}>
                Available Floors <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Total Floors
                    </Typography>
                    <TextField
                      id="totalFloors"
                      fullWidth
                      size="small"
                      placeholder="Enter total floors"
                      value={totalFloors}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setTotalFloors(value);
                        setErrors(prev => ({...prev, totalFloors: validateNumber(value, "Total floors", 1, 100)}));
                      }}
                      error={!!errors.totalFloors}
                      helperText={errors.totalFloors}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '185px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Select Floor
                    </Typography>
                    <FormControl fullWidth size="small" error={!!errors.selectedFloor}>
                      <Select
                        id="selectedFloor"
                        value={selectedFloor}
                        onChange={(e) => {
                          setSelectedFloor(e.target.value);
                          setErrors({...errors, selectedFloor: ''});
                        }}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled>Select Floor</MenuItem>
                        {[...Array(20)].map((_, i) => (
                          <MenuItem key={i + 1} value={`${i + 1}${i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor`}>
                            {i + 1}{i === 0 ? 'st' : i === 1 ? 'nd' : i === 2 ? 'rd' : 'th'} Floor
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.selectedFloor && <FormHelperText sx={{ fontSize: '11px' }}>{errors.selectedFloor}</FormHelperText>}
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Ownership
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedOwnership}
                        onChange={(e) => setSelectedOwnership(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Ownership</em></MenuItem>
                        {ownerships.map((own) => (
                          <MenuItem key={own} value={own}>{own}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm="auto">
                  <Box sx={{ width: '200px', maxWidth: '100%' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
                      Hub
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={selectedHub}
                        onChange={(e) => setSelectedHub(e.target.value)}
                        displayEmpty
                        sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
                      >
                        <MenuItem value="" disabled><em>Select Hub</em></MenuItem>
                        {hubs.map((hub) => (
                          <MenuItem key={hub} value={hub}>{hub}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

       {/* ✅ COMMERCIAL PLOT FIELDS */}
{isCommercial && isPlot && (
  <>
    {/* Social Media Link */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '410px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Social Media Link <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="socialMediaLink"
            fullWidth
            size="small"
            type="url"
            placeholder="YouTube, Facebook, WhatsApp, Instagram"
            value={socialMediaLink}
            onChange={(e) => {
              setSocialMediaLink(e.target.value);
              if (e.target.value) {
                setErrors(prev => ({...prev, socialMediaLink: validateSocialMediaLink(e.target.value)}));
              } else {
                setErrors(prev => ({...prev, socialMediaLink: ''}));
              }
            }}
            error={!!errors.socialMediaLink}
            helperText={errors.socialMediaLink}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LinkIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>
    </Grid>

    {/* Property Size, Zone Type, Ownership */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Property Size <span style={{ color: '#d32f2f' }}>*</span>
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField
              id="propertySize"
              fullWidth
              size="small"
              placeholder="Enter size"
              value={propertySize}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                setPropertySize(value);
                setErrors(prev => ({...prev, propertySize: validateNumber(value, "Property size")}));
              }}
              error={!!errors.propertySize}
              helperText={errors.propertySize}
              sx={{ 
                flex: 1,
                '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } 
              }}
            />
            <FormControl size="small" sx={{ minWidth: 100 }}>
              <Select
                value={selectedUnit}
                onChange={(e) => setSelectedUnit(e.target.value)}
                sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
              >
                <MenuItem value="sq.yards">Sq.Yards</MenuItem>
                <MenuItem value="acres">Acres</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Zone Type <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="zoneType"
            fullWidth
            size="small"
            placeholder="Enter zone type"
            value={zoneType}
            onChange={(e) => setZoneType(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Ownership <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <FormControl fullWidth size="small">
            <Select
              value={selectedOwnership}
              onChange={(e) => setSelectedOwnership(e.target.value)}
              displayEmpty
              sx={{ borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' }}
            >
              <MenuItem value=""><em>Select Ownership</em></MenuItem>
              {ownerships.map((own) => (
                <MenuItem key={own} value={own}>{own}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>
    </Grid>

    {/* Length and Width */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Length <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="propertyLength"
            fullWidth
            size="small"
            placeholder="Enter length"
            value={propertyLength}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, '');
              setPropertyLength(value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
            }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>

      <Grid item xs={12} sm="auto">
        <Box sx={{ width: '270px', maxWidth: '100%' }}>
          <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#333', fontFamily: 'Outfit', mb: 1 }}>
            Width <span style={{ color: '#999', fontSize: '11px' }}>(Optional)</span>
          </Typography>
          <TextField
            id="propertyWidth"
            fullWidth
            size="small"
            placeholder="Enter width"
            value={propertyWidth}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, '');
              setPropertyWidth(value);
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">Sq.Ft</InputAdornment>,
            }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, fontFamily: 'Outfit', fontSize: '13px' } }}
          />
        </Box>
      </Grid>
    </Grid>
  </>
)}
      </Box>
    );
  };

  return (
    <PostAccess
      currentStep={1}
      category={category}
      propertyType={propertyType}
      assetType={selectedPropertyType}
    >
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          maxWidth: { xs: '100%', md: '900px' },
          p: { xs: 2.5, sm: 3, md: 3.5 },
          backgroundColor: '#ffffff',
          borderRadius: 2,
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 600,
            mb: 0.5,
            fontSize: { xs: '18px', md: '22px' },
          }}
        >
          Add Property Details
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontSize: '13px',
            color: '#666',
            mb: 3,
          }}
        >
          {progress}% <span style={{ color: progress > 75 ? '#4caf50' : progress > 50 ? '#ff9800' : '#2196f3' }}>●●●○○</span>
        </Typography>

        {renderForm()}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 2,
            mt: 4,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleBack}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              color: '#666',
              borderColor: '#e0e0e0',
              minWidth: { xs: '80px', sm: '100px' },
            }}
          >
            Back
          </Button>

          <Button
            variant="contained"
            onClick={handleNext}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 1.5,
              textTransform: 'none',
              fontFamily: 'Outfit',
              fontSize: '13px',
              backgroundColor: '#1976d2',
              minWidth: { xs: '80px', sm: '100px' },
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            Next
          </Button>
        </Box>
      </Paper>

      {/* Image Preview Dialog */}
      {imagePreviews.length > 0 && (
        <Dialog
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{ '& .MuiDialog-paper': { borderRadius: '12px', overflow: 'hidden', bgcolor: 'black' } }}
        >
          <DialogContent sx={{ p: 0, position: 'relative' }}>
            <Box
              component="img"
              src={imagePreviews[selectedImageIndex]}
              alt={`Image ${selectedImageIndex + 1}`}
              sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain' }}
            />
            <IconButton
              onClick={() => setPreviewOpen(false)}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                bgcolor: 'rgba(255, 255, 255, 0.3)',
                color: 'white',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
              }}
            >
              <CloseIcon />
            </IconButton>
            {imagePreviews.length > 1 && (
              <>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev > 0 ? prev - 1 : imagePreviews.length - 1))}
                  sx={{
                    position: 'absolute',
                    left: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ‹
                </IconButton>
                <IconButton
                  onClick={() => setSelectedImageIndex(prev => (prev < imagePreviews.length - 1 ? prev + 1 : 0))}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    bgcolor: 'rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.5)' }
                  }}
                >
                  ›
                </IconButton>
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bgcolor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: '16px',
                    fontSize: '14px',
                    fontFamily: 'Outfit'
                  }}
                >
                  {selectedImageIndex + 1} / {imagePreviews.length}
                </Box>
              </>
            )}
          </DialogContent>
        </Dialog>
      )}
    </PostAccess>
  );
};

export default PropertyDetails;